// teluce.js — refuerzos de marca en quantity offers de Releasit
// 1) "Te ahorras -$X" en cada card de oferta (calculado desde precios reales).
// 2) Microcopy dinámico bajo el selector de cantidad: al sumar unidades, avisa
//    qué descuento se activó. Las ofertas se LEEN de window._RSI_COD_FORM_QUANTIY_OFFERS
//    (config del form de Releasit) — nada hardcodeado, se adapta al admin.
(function () {
  'use strict';

  var MOBILE_QUERY = window.matchMedia('(max-width: 749px)');
  // ahorro real por tramo (qty -> pesos), poblado por updateCard desde los
  // precios del DOM de Releasit; lo consumen los steps del progress.
  var saveByQty = {};

  // ---------- utilidades moneda (formato COP: "$209.700,00") ----------
  function moneyToNumber(text) {
    if (!text) return NaN;
    var cleaned = text.replace(/[^0-9.,]/g, '').replace(/\./g, '').replace(',', '.');
    var n = parseFloat(cleaned);
    return isFinite(n) ? n : NaN;
  }

  function moneyToText(n) {
    // pesos enteros (sin ,00) — COP no usa centavos en la percepción de precio
    return '$' + Math.round(n).toLocaleString('es-CO');
  }

  // ---------- "Te ahorras -$X" en las cards ----------
  function findBadgeDiv(wrapper) {
    var plaque = wrapper.parentNode.querySelector('.rsi-quantity-plaque');
    return plaque ? plaque.parentNode : null;
  }

  function placeSave(span, wrapper) {
    var mobile = MOBILE_QUERY.matches;
    var target = mobile ? wrapper.parentNode : wrapper;
    if (span.parentNode === target) return;
    if (mobile) {
      wrapper.parentNode.insertBefore(span, findBadgeDiv(wrapper));
    } else {
      wrapper.appendChild(span);
    }
  }

  function updateCard(card) {
    var wrapper = card.querySelector('.rsi-quantity-price-wrapper');
    var oldEl = card.querySelector('.rsi-quantity-old-price');
    if (!wrapper || !oldEl) return;

    var oldValue = moneyToNumber(oldEl.textContent);
    var clone = wrapper.cloneNode(true);
    var oldClone = clone.querySelector('.rsi-quantity-old-price');
    if (oldClone) oldClone.parentNode.removeChild(oldClone);
    var realValue = moneyToNumber(clone.textContent);

    if (!isFinite(oldValue) || !isFinite(realValue) || realValue >= oldValue) return;

    // memoria del ahorro real por tramo (qty -> pesos): lo consumen los steps
    // del progress para mostrar "-$X" sobre el boceto del tramo logrado. Sale
    // SIEMPRE del DOM de Releasit (precio original - precio con descuento),
    // nunca hardcodeado.
    var radio = card.querySelector('input[type="radio"]');
    var idx = parseInt((radio && radio.value || '').replace('quantity_', ''), 10);
    var cfg = window._RSI_COD_FORM_QUANTIY_OFFERS;
    if (isFinite(idx) && cfg && cfg[0] && cfg[0].offers[idx]) {
      saveByQty[cfg[0].offers[idx].qty] = oldValue - realValue;
    }

    var text = 'Te ahorras -' + moneyToText(oldValue - realValue);
    var span = card.querySelector('.teluce-save');
    if (!span) {
      span = document.createElement('span');
      span.className = 'teluce-save';
      span.textContent = text;
      placeSave(span, wrapper);
    } else {
      if (span.textContent !== text) span.textContent = text;
      placeSave(span, wrapper);
    }
  }

  function updateCards() {
    document.querySelectorAll('.rsi-quantity-product').forEach(updateCard);
  }

  // ---------- barra de progreso + storytelling bajo la botonera ----------
  function getOffers() {
    var cfg = window._RSI_COD_FORM_QUANTIY_OFFERS;
    if (!cfg || !cfg.length) return null;
    // ofertas con descuento real: qty > 1 y ds.t === "percentage"
    var offers = cfg[0].offers.filter(function (o) {
      return o.qty > 1 && o.ds && o.ds.t === 'percentage' && o.ds.v > 0;
    });
    if (!offers.length) return null;
    offers.sort(function (a, b) { return a.qty - b.qty; });
    return offers.map(function (o) {
      return { qty: o.qty, pct: Math.round(o.ds.v / 100), save: saveByQty[o.qty] || 0 };
    });
  }

  // Camiseta negra (silueta del producto) con número blanco bold — MISMA
  // identidad que los variant pickers de Releasit (viewBox 32x24, torso ancho).
  // El relleno y el color del número los pone el CSS (nunca hardcodeados acá).
  function shirtSVG(num) {
    return '<svg class="teluce-qty-progress__shirt" viewBox="0 0 32 24" aria-hidden="true">' +
      '<path d="M12 2L8 3.5 2.5 7.5 6.5 12 7.5 10.5 7.5 22 24.5 22 24.5 10.5 25.5 12 29.5 7.5 24 3.5 20 2 17.5 4 14.5 4Z"/>' +
      '<text x="16" y="14.5" text-anchor="middle" font-size="9" font-weight="800">' + num + '</text>' +
    '</svg>';
  }

  // Candado grande: reemplaza la camiseta en los pasos de oferta NO alcanzados
  // (contador en 1). Al desbloquear el tramo, la camiseta vuelve a aparecer.
  function lockSVG() {
    return '<svg class="teluce-qty-progress__lock" viewBox="0 0 24 24" aria-hidden="true">' +
      '<path class="teluce-lock__body" d="M7 11h10a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1z"/>' +
      '<path class="teluce-lock__shackle" d="M8.5 11V7.5a3.5 3.5 0 0 1 7 0V11"/>' +
    '</svg>';
  }

  // Badge bajo cada paso: la 1 muestra "Precio full" fijo; las de oferta
  // muestran el -X% dentro de un pill glass (el ÚLTIMO tramo, protagonista,
  // lleva la clase --last y usa el estilo fuerte de la card X3 de Releasit;
  // los intermedios usan el estilo secundario X2).
  function badgeHTML(idx, step, isLast) {
    if (idx === 0) {
      return '<span class="teluce-qty-badge">Precio full</span>';
    }
    return '<span class="teluce-qty-badge">' +
      '<span class="teluce-qty-badge__pct' + (isLast ? ' teluce-qty-badge__pct--last' : '') + '">-' + step.pct + '%</span>' +
    '</span>';
  }

  // ordinales cortos para la invitación ("Compra la 2da prenda...")
  function ordinalText(qty) {
    var map = { 1: '1ra', 2: '2da', 3: '3ra', 4: '4ta', 5: '5ta' };
    return map[qty] || (qty + 'ta');
  }

  // el % como protagonista tipográfico del copy: envuelto en un span dedicado
  // (teluce-qty-progress__pct) que el CSS agranda y colorea. El número entra
  // SIEMPRE del config Releasit (step.pct), nunca hardcodeado.
  function pctSpan(pct) {
    return '<span class="teluce-qty-progress__pct">' + pct + '%</span>';
  }

  // la llama del hito: flanquea el copy de los estados de logro (tier1/tier2)
  // para marcar el momento en que se desbloquea un descuento. Emoji real del
  // sistema: sin assets, escala con la fuente del mensaje (CSS lo agranda).
  function flameSpan() {
    return '<span class="teluce-qty-progress__flame">🔥</span>';
  }

  // "Ahorraste: -$X" que va SOBRE el boceto del tramo logrado: el premio
  // concreto en pesos (con signo menos = ahorro). Sale de saveByQty (precios
  // reales de Releasit), nunca hardcodeado. UNA línea: el label secundario
  // (semibold, chico) seguido del valor protagonista (bold, más grande) —
  // "Ahorraste:" + "-$20.970" juntos. Se crea vacío y labelStepSaves rellena.
  function saveStepHTML() {
    return '<span class="teluce-qty-progress__step-save">' +
      '<span class="teluce-qty-progress__save-label">Ahorraste:</span>' +
      '<span class="teluce-qty-progress__save-value"></span>' +
    '</span>';
  }

  function labelStepSaves() {
    document.querySelectorAll('.teluce-qty-progress__step').forEach(function (step) {
      var el = step.querySelector('.teluce-qty-progress__step-save');
      if (!el) return;
      var qty = parseInt(step.getAttribute('data-qty'), 10);
      var save = saveByQty[qty] || 0;
      var clean = save > 0 ? 'Ahorraste:-$' + Math.round(save).toLocaleString('es-CO') : '';
      if (el.getAttribute('data-text') !== clean) {
        el.querySelector('.teluce-qty-progress__save-value').textContent = save > 0 ? '-$' + Math.round(save).toLocaleString('es-CO') : '';
        el.setAttribute('data-text', clean);
      }
    });
  }

  function buildProgress() {
    var host = document.querySelector('.product-form__quantity');
    if (!host) return null;
    var container = host.querySelector('.price-per-item__container');
    var stepper = (container || host).querySelector('quantity-input.quantity') || host.querySelector('.quantity');
    var root = host.querySelector('.teluce-qty-progress');
    if (!root) {
      // el componente (track + msg) va DESPUÉS del container (full-width):
      // el container queda libre para el flex stepper + aviso de límite.
      root = document.createElement('div');
      root.className = 'teluce-qty-progress';
      root.innerHTML =
        '<div class="teluce-qty-progress__track">' +
          '<div class="teluce-qty-progress__fill"></div>' +
        '</div>' +
        '<p class="teluce-qty-progress__msg"></p>';
      var anchorRoot = container || stepper || host;
      anchorRoot.insertAdjacentElement('afterend', root);
    } else if (container && root.parentElement === container) {
      // migración: el root quedó DENTRO del container (versión anterior con
      // display:block apilado) — lo sacamos para que el container pueda ser
      // flex row con el aviso al lado del stepper.
      container.insertAdjacentElement('afterend', root);
    }
    // aviso del límite: hermano del stepper DENTRO del container, al lado de
    // los botones −/+, ocupando el espacio restante. Idempotente: si ya está
    // en el container (o dentro del root por migración), solo se re-ubica.
    var limit = host.querySelector('.teluce-qty-progress__limit');
    if (!limit) {
      limit = document.createElement('div');
      limit.className = 'teluce-qty-progress__limit';
    }
    var limitDest = container || host;
    if (limit.parentElement !== limitDest) {
      (stepper || limitDest).insertAdjacentElement('afterend', limit);
    }
    // migración segura: si venía de la versión vieja sin steps, limpiar el track
    var track = root.querySelector('.teluce-qty-progress__track');
    if (track && !track.querySelector('.teluce-qty-progress__step')) {
      track.innerHTML = '<div class="teluce-qty-progress__fill"></div>';
    }
    return root;
  }

  function labelSteps(offers) {
    var track = document.querySelector('.teluce-qty-progress__track');
    if (!track) return;
    // pasos: base (qty 1, sin descuento) + cada oferta
    var maxQty = offers[offers.length - 1].qty;
    var steps = [{ qty: 1, pct: 0 }].concat(offers);

    steps.forEach(function (s, i) {
      var step = track.querySelector('.teluce-qty-progress__step[data-index="' + i + '"]');
      if (!step) {
        step = document.createElement('span');
        step.className = 'teluce-qty-progress__step';
        step.setAttribute('data-index', i);
        step.setAttribute('data-qty', s.qty);
        // el step 0 ("Precio full") nunca lleva candado; los de oferta (i>0)
        // se crean con camiseta + candado grande + badge (+ slot del ahorro)
        step.innerHTML = (i > 0 ? saveStepHTML() : '') + shirtSVG(s.qty) + (i > 0 ? lockSVG() : '') + badgeHTML(i, s, i === offers.length);
        track.appendChild(step);
      } else if (i > 0 && !step.querySelector('.teluce-qty-progress__lock')) {
        // migración: steps de oferta creados con el diseño anterior (candado
        // chico en el badge) se re-renderizan con el candado grande que
        // reemplaza la camiseta. El step 0 ("Precio full") nunca lleva candado.
        step.innerHTML = saveStepHTML() + shirtSVG(s.qty) + lockSVG() + badgeHTML(i, s, i === offers.length);
      }
    });
    // limpiar steps huérfanos si cambió el número de ofertas
    var stepsEl = track.querySelectorAll('.teluce-qty-progress__step');
    stepsEl.forEach(function (el) {
      var idx = parseInt(el.getAttribute('data-index'), 10);
      if (!steps[idx]) el.parentNode.removeChild(el);
    });
  }

  function updateQtyMsg() {
    var offers = getOffers();
    if (!offers) return;
    var root = buildProgress();
    if (!root) return;

    var host = document.querySelector('.product-form__quantity');
    var input = host.querySelector('input[name="quantity"]');
    var qty = input ? parseInt(input.value, 10) : 1;
    if (!isFinite(qty) || qty < 1) qty = 1;

    var maxQty = offers[offers.length - 1].qty;
    // tope de compra: el descuento aplica hasta la última oferta (maxQty).
    // El atributo max hace que Dawn (QuantityInput → validateQtyRules) marque
    // el botón "+" como disabled en cada change, y stepUp() respeta el límite
    // aunque el click pase. El clamp cubre el teclado numérico móvil (escribir
    // "4" a mano no deja que Releasit lea nunca más de maxQty).
    if (input) {
      input.max = String(maxQty);
      if (qty > maxQty) {
        input.value = String(maxQty);
        qty = maxQty;
      }
      // feedback visual inmediato del tope: mismo patrón de Dawn (toggle de la
      // clase disabled en el "+"), sin esperar el evento change.
      var btnPlus = host.querySelector(".quantity__button[name='plus']");
      if (btnPlus) btnPlus.classList.toggle('disabled', qty >= maxQty);
    }
    // hitIndex: último paso alcanzado (paso base = índice 0)
    var hitIndex = 0;
    offers.forEach(function (o, i) { if (o.qty <= qty) hitIndex = i + 1; });

    labelSteps(offers);

    var fill = root.querySelector('.teluce-qty-progress__fill');
    var msg = root.querySelector('.teluce-qty-progress__msg');
    // progreso lineal: 0% en qty=1, 100% en el máximo
    var progress = maxQty > 1 ? Math.min(Math.max((qty - 1) / (maxQty - 1), 0), 1) : 1;

    // estados: start (0%), tier1, tier2, over (pasó el máximo)
    root.classList.remove(
      'teluce-qty-progress--start',
      'teluce-qty-progress--tier1',
      'teluce-qty-progress--tier2',
      'teluce-qty-progress--over'
    );

    // encender steps alcanzados (la camiseta 1 siempre está encendida);
    // los steps de oferta no alcanzados quedan "bloqueados" (candado visible).
    // Badge -X% visible SOLO donde comunica el premio vigente: oculto
    // (is-badge-hidden) en todo tramo no desbloqueado
    // se ven antes de desbloquear (en qty=1 ambos steps son solo candado, el
    // % se revela al desbloquear). El ANTICIPO gris del tramo siguiente: el
    // step 2 con la invitación del intro (qty=1, medio avance 1->2) y el último
    // con la del upsell (qty=2, medio avance 2->3). Al volver a un qty menor,
    // los badges vuelven a ocultarse.
    var steps = root.querySelectorAll('.teluce-qty-progress__step');
    steps.forEach(function (s, i) {
      s.classList.toggle('is-lit', i <= hitIndex);
      s.classList.toggle('is-locked', i > 0 && i > hitIndex);
      // is-current: SOLO el tramo vigente logrado (i === hitIndex). El valor
      // "-$X" sobre el boceto y el badge % solo se muestran ahí — al llegar al
      // máximo, el tramo anterior queda con su check pero sin pill ni valor que
      // compitan con el premio vigente.
      s.classList.toggle('is-current', i > 0 && i === hitIndex);
      // badge visible: el tramo vigente (i === hitIndex, ya desbloqueado) o el
      // ANTICIPO gris del tramo siguiente — el step 2 con la invitación del
      // intro (qty=1, medio avance 1->2) y el último con la del upsell
      // (qty=2, medio avance 2->3). El pill gris sale del estilo locked base.
      var showBadge = (i > 0 && i === hitIndex) ||
        (introPlayed && i === 1 && hitIndex === 0) ||
        (upsellPlayed && i === offers.length && hitIndex === offers.length - 1);
      s.classList.toggle('is-badge-hidden', i > 0 && !showBadge);
    });

      var newMsg;
      if (hitIndex === 0) {
        root.classList.add('teluce-qty-progress--start');
        // SIN mensaje inicial: la propuesta ("Compra la 2da prenda...") aparece
        // recién con el intro de bienvenida, cuando el componente estuvo lo
        // suficiente en el centro de atención del usuario. El % sale SIEMPRE del
        // config Releasit (getOffers), nunca hardcodeado. El % va envuelto en
        // un span protagonista (jerarquía tipográfica: el número primero).
        newMsg = introPlayed
          ? 'Compra la ' + ordinalText(offers[0].qty) + ' prenda y recibes un ' + pctSpan(offers[0].pct) + ' de descuento'
          : '';
      } else if (qty > maxQty) {
        // red de seguridad: con el tope (input.max + clamp) es inalcanzable,
        // pero si algo lo alcanzara no repetimos la frase que confundió
        // ("Mantienes el 15%") — el límite se comunica atado al beneficio.
        root.classList.add('teluce-qty-progress--over');
        newMsg = 'El descuento aplica hasta ' + maxQty + ' prendas por pedido';
      } else if (hitIndex >= offers.length) {
        root.classList.add('teluce-qty-progress--tier2');
        newMsg = flameSpan() + '¡TE LUCISTE con ese ' + pctSpan(offers[offers.length - 1].pct) + ' total de descuento!' + flameSpan();
      } else {
        root.classList.add('teluce-qty-progress--tier1');
        // con upsellPlayed (invitación a la 3ra, ver playUpsell) el mensaje se
        // vuelve COMBINADO: confirma el premio ya asegurado (neutro, strong) y
        // al mismo tiempo invita al siguiente (protagonista terracota). El 10%
        // ganado nunca desaparece del mensaje: el usuario no duda de lo que ya
        // tiene. Los % salen SIEMPRE del config Releasit, nunca hardcodeados.
        newMsg = upsellPlayed
          ? 'Ya tienes <strong>' + offers[hitIndex - 1].pct + '%</strong> por las ' + offers[hitIndex - 1].qty + '. ¿Y las ' + offers[1].qty + ' con ' + pctSpan(offers[1].pct) + '?'
          : flameSpan() + '¡Cómo TE LUCE ese ' + pctSpan(offers[hitIndex - 1].pct) + ' de descuento!' + flameSpan();
      }
    // celebración por tramo: se dispara la PRIMERA vez que cada descuento se
    // activa (step 2 al llegar a qty 2, step 3 al llegar a qty 3), no al
    // re-desbloquear (3→2→3 no repite). El marker --celebrating en el step que
    // acaba de desbloquearse scopea la secuencia solo a ese candado (si no,
    // al animar el 3 el 2 re-animaba su candado también). La clase --celebrated
    // de la raíz se quita solo cuando NINGÚN step sigue celebrando: si el 2 y
    // el 3 se desbloquean casi juntos, el timer del primero no corta la
    // secuencia del segundo.
    if (hitIndex > 0 && !celebratedSteps[hitIndex]) {
      celebratedSteps[hitIndex] = true;
      celebratingCount++;
      root.classList.add('teluce-qty-progress--celebrated');
      steps[hitIndex].classList.add('teluce-qty-progress__step--celebrating');
      setTimeout(function () {
        if (steps[hitIndex]) steps[hitIndex].classList.remove('teluce-qty-progress__step--celebrating');
        celebratingCount--;
        if (celebratingCount <= 0) root.classList.remove('teluce-qty-progress--celebrated');
      }, 1500);
    }
    // guard: innerHTML SIEMPRE reemplaza el nodo -> muta el DOM -> alimenta el
    // MutationObserver -> loop infinito. Comparar contra el ÚLTIMO html escrito
    // (no contra msg.innerHTML: el navegador normaliza y nunca coincidiría).
    if (lastMsgHtml !== newMsg) {
      msg.innerHTML = newMsg;
      lastMsgHtml = newMsg;
    }

    // aviso del límite: visible SOLO en el máximo (qty === maxQty). Vive AL LADO
    // de la botonera de cantidad (flex con el stepper), no en un banner: el
    // mensaje aparece donde está la acción (junto al "+" recién deshabilitado).
    // Jerarquía Malewicz en un solo grupo con fondo: interés (el 3 prota),
    // clarificación ("¿Deseas más?") y la acción (botón WhatsApp con icono,
    // mismo gradiente verde que los CTA del theme). El link wa.me usa el
    // número real del theme y precarga el producto concreto.
    var limit = document.querySelector('.teluce-qty-progress__limit');
    if (limit) {
      var titleEl = document.querySelector('.product__title h1');
      var pTitle = titleEl ? titleEl.textContent.replace(/\s+/g, ' ').trim() : '';
      if (!pTitle) pTitle = 'este producto';
      var waHref = 'https://wa.me/573178315988?text=' +
        encodeURIComponent('Hola! Quiero pedir más de ' + maxQty + ' unidades de ' + pTitle + '. ¿Me ayudas?');
      var waIcon = '<svg class="icon icon-whatsapp" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
        '<path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.52.149-.174.198-.298.297-.497.1-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z"/>' +
        '</svg>';
      var limitHtml = qty >= maxQty
        ? '<p class="teluce-qty-progress__limit-head">Descuentos aplican en máx. <strong>' + maxQty + '</strong> prendas</p>' +
          '<div class="teluce-qty-progress__limit-act">' +
            '<span class="teluce-qty-progress__limit-ask">¿Deseas más?</span>' +
            '<a class="teluce-qty-progress__limit-wa" href="' + waHref + '" target="_blank" rel="noopener">' + waIcon + ' Escríbenos</a>' +
          '</div>'
        : '';
      if (lastLimitHtml !== limitHtml) {
        limit.innerHTML = limitHtml;
        lastLimitHtml = limitHtml;
      }
    }

    // barra recortada: empieza en el centro de la camiseta 1 y termina en el
    // centro de la última. Medimos los centros reales (maneja 36px desktop y
    // 30px mobile, y cualquier cantidad de steps). left/width en px; resize
    // re-mide porque schedule() vuelve a llamar updateQtyMsg.
    var trackEl = root.querySelector('.teluce-qty-progress__track');
    if (trackEl && steps.length > 1) {
      var trackRect = trackEl.getBoundingClientRect();
      var firstRect = steps[0].getBoundingClientRect();
      var lastRect = steps[steps.length - 1].getBoundingClientRect();
      var start = firstRect.left + firstRect.width / 2 - trackRect.left;
      var end = lastRect.left + lastRect.width / 2 - trackRect.left;
      fill.style.left = start + 'px';
      // invitaciones: en qty=1 el intro avanza la barra a la mitad del tramo
      // 1->2 y en qty=2 el upsell a la mitad del tramo 2->3; ambas se quedan.
      // Al cambiar qty, el progreso real la pisa (updateQtyMsg re-mide).
      var secondRect = steps[1] ? steps[1].getBoundingClientRect() : null;
      var secondCenter = secondRect ? secondRect.left + secondRect.width / 2 - trackRect.left : 0;
      if (introPlayed && hitIndex === 0 && steps[1]) {
        fill.style.width = ((secondCenter - start) / 2) + 'px';
      } else if (upsellPlayed && hitIndex === 1 && steps[2]) {
        // la punta debe quedar en la MITAD del tramo 2->3: desde start
        // (left del fill) hay que recorrer el tramo 1->2 completo + medio tramo
        // 2->3. width se mide desde left=start, así que NO puede ser solo
        // (thirdCenter - secondCenter) / 2 (eso quedaba a mitad del tramo 1->2).
        var thirdRect = steps[2].getBoundingClientRect();
        var thirdCenter = thirdRect.left + thirdRect.width / 2 - trackRect.left;
        fill.style.width = ((secondCenter - start) + (thirdCenter - secondCenter) / 2) + 'px';
      } else {
        fill.style.width = (progress * (end - start)) + 'px';
      }
    } else {
      fill.style.left = '0';
      fill.style.width = (progress * 100) + '%';
    }
  }

  // ---------- orquestación ----------
  var timer = null;
  // celebración del unlock por tramo: cada step anima la PRIMERA vez que se
  // desbloquea; los re-desbloqueos (3→2→3) no repiten (ver updateQtyMsg).
  // celebratingCount evita que un timer corte la secuencia de otro step.
  var celebratedSteps = {};
  var celebratingCount = 0;
  // intro de bienvenida: UNA vez por carga, cuando el componente estuvo ~60%
  // visible por 1.5s continuos (ver playIntro al final).
  var introPlayed = false;
  var introTimer = null;
  // upsell 2da -> 3ra prenda: UNA vez por carga, cuando el usuario llega a
  // qty=2 y pasan 3.5s (celebración del 10% + pausa), invita a la 3ra.
  var upsellPlayed = false;
  var upsellTimer = null;
  // guard del msg: último html escrito (comparar contra msg.innerHTML normaliza
  // el html del navegador y rompería la igualdad -> loop infinito del observer).
  var lastMsgHtml = null;
  // guard del aviso de límite: mismo patrón, evita re-escribir el link wa.me
  // en cada update y corta el loop del observer.
  var lastLimitHtml = null;

  // ---------- sincronización card -> quantity ----------
  // Releasit marca el radio al clickear una card pero NO actualiza el input
  // quantity (y no dispara eventos). Sincronizamos el input al qty de la oferta
  // seleccionada (cantidad real del config, nunca hardcodeada). Guard: si el
  // input ya coincide con el qty de la card, no tocamos nada (corta cualquier
  // loop observer<->input). Seteamos el valor SIN disparar eventos: el form del
  // theme lee el input al agregar al carrito, y el observer ya corre por el
  // re-render de Releasit (evita re-fetch del upsell).
  function qtyOfCard(card) {
    var cfg = window._RSI_COD_FORM_QUANTIY_OFFERS;
    if (!cfg || !cfg.length) return null;
    var radio = card.querySelector('input[type="radio"]');
    if (!radio) return null;
    var idx = parseInt((radio.value || '').replace('quantity_', ''), 10);
    if (!isFinite(idx) || !cfg[0].offers[idx]) return null;
    return String(cfg[0].offers[idx].qty);
  }

  function syncQtyFromCard(card) {
    var qInput = document.querySelector('.product-form__quantity input[name="quantity"]');
    if (!qInput || !card) return;
    var targetQty = qtyOfCard(card);
    if (!targetQty) return;
    if (qInput.value === targetQty) return; // ya sincronizado -> sin loop
    qInput.value = targetQty;
  }

  // indicador de prenda (1., 2., 3. de Releasit) -> camiseta negra con número
  // blanco bold: extrae el número al atributo data-n (lo pinta el CSS en ::before)
  // y vacía el texto original (el punto "1." no se ve sobre la silueta).
  function labelVariantNumbers() {
    document.querySelectorAll('.rsi-variant-picker-vn').forEach(function (vn) {
      var m = /^\s*(\d+)/.exec(vn.textContent || '');
      if (!m) return;
      if (vn.getAttribute('data-n') === m[1] && !vn.textContent.trim()) return; // ya listo
      vn.setAttribute('data-n', m[1]);
      vn.textContent = '';
    });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      labelVariantNumbers();
      updateCards();
      labelStepSaves();
      updateQtyMsg();
      maybeScheduleUpsell();
    }, 100);
  }

  // Releasit renderiza/actualiza por React: observar el DOM
  var observer = new MutationObserver(schedule);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  // click en una card de Releasit: sincronizar input quantity + barra + upsell
  // al instante (sin esperar el fetch + re-render de Releasit, que tarda ~1s).
  // Leemos el radio de la card clickeada (aún no checked en ese instante).
  // El guard de syncQtyFromCard corta el loop cuando el observer re-corre con
  // el input ya sincronizado. El observer NO sincroniza el qty por su cuenta:
  // en el instante del click el radio checked aún es la card anterior y volvería
  // el qty hacia atrás (rebote 2->1->2); el input lo manda el click handler.
  document.addEventListener('click', function (e) {
    var card = e.target && e.target.closest && e.target.closest('.rsi-quantity-product');
    if (card) {
      syncQtyFromCard(card);
      updateQtyMsg();
      maybeScheduleUpsell();
      // seleccionar una card de oferta también es señal de intención de compra:
      // auto-scroll suave (mobile) para dejar la zona Cantidad -> CTA en primer plano
      ensureOfferZoneInView();
    }
  }, true);

  // El usuario toca el selector nativo: escuchar también el evento directo
  document.addEventListener('input', function (e) {
    if (e.target && e.target.matches && e.target.matches('input[name="quantity"]')) {
      clearTimeout(timer);
      timer = setTimeout(function () { updateQtyMsg(); maybeScheduleUpsell(); }, 50);
      // intención detectada: auto-scroll suave para llevar la zona de oferta
      // (Cantidad -> CTA) al primer plano (ver ensureOfferZoneInView).
      ensureOfferZoneInView();
    }
  });

  // Auto-scroll de acompañamiento (mobile only): cuando el usuario muestra
  // intención de compra (toca el stepper, cambia la cantidad o selecciona una
  // card de oferta de Releasit), si la zona de Cantidad -> CTA no está completa
  // en pantalla, scrollea suave para dejarla en primer plano. NO es invasivo:
  // acompaña la acción (no la aparición al scrollear), una sola vez por gesto,
  // y solo si falta contexto. El scroll nativo respeta prefers-reduced-motion
  // en los navegadores modernos.
  var offerZoneScrollFired = false;
  function offerZoneNeedsScroll() {
    if (window.innerWidth >= 750) return false; // desktop: la columna sticky ya la mantiene a la vista
    if (offerZoneScrollFired) return false; // una sola vez por carga (tras el primer gesto)
    var startEl = document.querySelector('.product-form__quantity');
    var ctaEl = document.querySelector('.product-form__buttons');
    if (!startEl || !ctaEl) return false;
    var r = ctaEl.getBoundingClientRect();
    // falta contexto: el CTA (final de la zona) asoma apenas o está fuera de vista
    return r.bottom > window.innerHeight * 0.85;
  }
  function ensureOfferZoneInView() {
    if (!offerZoneNeedsScroll()) return;
    var startEl = document.querySelector('.product-form__quantity');
    var ctaEl = document.querySelector('.product-form__buttons');
    if (!startEl || !ctaEl) return;
    // alinear el INICIO de la zona (Cantidad) arriba: deja Cantidad, barra de
    // progreso y CTA juntos en pantalla. scrollIntoView nativo, suave.
    offerZoneScrollFired = true; // marcar ANTES: si el smooth se interrumpe no reintentar en cada input
    startEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  // el tap en el stepper también es señal de intención (cubre el caso de tocar
  // el + sin llegar a cambiar el valor por input en algunos navegadores)
  document.addEventListener('pointerdown', function (e) {
    if (e.target && e.target.closest && e.target.closest('quantity-input.quantity')) {
      ensureOfferZoneInView();
    }
  }, true);

  window.addEventListener('resize', schedule);
  updateCards();
  updateQtyMsg();

  // ---------- intro de bienvenida (invitación) ----------
  // Cuando el componente estuvo ~60% visible por 1.5s continuos (scroll o ya
  // en pantalla), juega UNA vez por carga: la barra avanza a la mitad del
  // primer tramo y se queda, el mensaje propone la 2da prenda (con el % del
  // config Releasit) y el candado del step 2 amaga abrirse (marker temporal
  // --feinting; el step sigue is-locked, nunca se desbloquea de verdad).
  function playIntro() {
    introPlayed = true;
    updateQtyMsg();
    var step2 = document.querySelector('.teluce-qty-progress__step[data-index="1"]');
    if (step2) {
      step2.classList.add('teluce-qty-progress__step--feinting');
      setTimeout(function () {
        step2.classList.remove('teluce-qty-progress__step--feinting');
      }, 800);
    }
  }
  // upsell a la 3ra prenda: cuando el usuario llega a qty=2, tras ~2.5s
  // (celebración del 10% ~2.1s + pausa corta) se ofrece la 3ra: el mensaje
  // cambia, la barra avanza a la mitad del tramo 2->3 y se queda, y el candado
  // del step 3 amaga abrirse (marker --feinting; sigue is-locked). UNA vez por
  // carga (upsellPlayed), como el intro.
  function playUpsell() {
    upsellPlayed = true;
    updateQtyMsg();
    var step3 = document.querySelector('.teluce-qty-progress__step[data-index="2"]');
    if (step3) {
      step3.classList.add('teluce-qty-progress__step--feinting');
      setTimeout(function () {
        step3.classList.remove('teluce-qty-progress__step--feinting');
      }, 800);
    }
  }
  // arranca el timer del upsell cuando el usuario está en qty=2 y aún no se
  // ofreció; si sale de qty=2, lo cancela (al volver a 2 arranca fresco).
  function maybeScheduleUpsell() {
    var input = document.querySelector('.product-form__quantity input[name="quantity"]');
    var qty = input ? parseInt(input.value, 10) : 1;
    if (qty !== 2) {
      if (upsellTimer) { clearTimeout(upsellTimer); upsellTimer = null; }
      return;
    }
    if (upsellPlayed || upsellTimer) return;
    upsellTimer = setTimeout(function () {
      upsellTimer = null;
      // guard: releer qty al disparar; si ya no está en 2 (subió a 3 o bajó
      // a 1) no se ofrece.
      var inputNow = document.querySelector('.product-form__quantity input[name="quantity"]');
      var qtyNow = inputNow ? parseInt(inputNow.value, 10) : 1;
      if (!upsellPlayed && qtyNow === 2) playUpsell();
    }, 2500);
  }
  var introRoot = buildProgress();
  if (introRoot && 'IntersectionObserver' in window) {
    var introObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
          if (!introPlayed && !introTimer) {
            introTimer = setTimeout(function () {
              introTimer = null;
              if (!introPlayed) {
                var input = document.querySelector('.product-form__quantity input[name="quantity"]');
                var qty = input ? parseInt(input.value, 10) : 1;
                // la invitación aplica solo en estado inicial (qty=1); si ya
                // está comprando, se marca como vista y no se ofrece
                if (qty <= 1) playIntro(); else introPlayed = true;
              }
            }, 1500);
          }
        } else {
          clearTimeout(introTimer);
          introTimer = null;
        }
      });
    }, { threshold: [0.6] });
    introObserver.observe(introRoot);
  }
})();

// teluce mix-match pack builder — ponytail: Store + 2-step Back Down South + PackAssembler all-or-nothing
(function(){
  'use strict';

  // ---------- telemetría del pack ----------
  // El pack es 100% custom: los eventos estándar de Shopify NO disparan acá
  // (el add va por fetch a /cart/add.js y Releasit usa su propio carrito
  // GraphQL). Así que publicamos eventos PROPIOS:
  //   1) Shopify.analytics.publish -> lo reciben los Custom Pixels del Admin
  //      (que los reenvían a GA4/Meta). Prefijo `teluce:` por convención.
  //   2) Clarity: `event` para el funnel, `set` para filtrar recordings y
  //      `upgrade` para que no se pierdan las sesiones que importan.
  // No-op si ninguno está disponible: NUNCA rompe la UI.
  // Una sola priorización por sesión: si se pidiera en cada evento,
  // "priorizar" pasaría a ser "priorizar todo" y dejaría de servir.
  var clarityPriorizada = false;
  function teluceTrack(name, props){
    props = props || {};
    try{
      if(window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function'){
        Shopify.analytics.publish('teluce:' + name, props);
      }
    }catch(e){}
    try{
      if(typeof window.clarity === 'function'){
        window.clarity('event', 'teluce_' + name);
        if(props.tier != null) window.clarity('set', 'pack_tier', String(props.tier));
        if(props.zone) window.clarity('set', 'fit_zone', String(props.zone));
        // Clarity decide por su cuenta qué sesiones graba, así que las que
        // valen la pena mirar se piden explícitamente: la que confirma compra
        // y los dos momentos con intención real (abre el drawer, suma prenda).
        // `name` va en el motivo para poder distinguirlas en Clarity.
        if(!clarityPriorizada && (name === 'confirm' || name === 'drawer_open' || name === 'slot_add')){
          clarityPriorizada = true;
          window.clarity('upgrade', 'teluce_' + name);
        }
      }
    }catch(e){}
  }

  // Releasit monta su formulario en un <dialog> NATIVO y tarda varios segundos
  // en aparecer DESPUES de que su boton ya existe. Este helper avisa cuando el
  // form esta realmente en pantalla, que es cuando corresponde soltar el estado
  // de carga: si se suelta al encontrar el boton, el boton vuelve a verse
  // inactivo justo durante la espera (y el shimmer/spinner desaparecen, que era
  // justo lo que se veia como hueco).
  //
  // La senal es GENERICA a proposito: un <dialog> nativo abierto. El theme NO
  // usa <dialog> nativos (sus modales son <modal-dialog>, un custom element de
  // Dawn), asi que el unico que puede aparecer es el form de Releasit. No
  // depende de ningun nombre interno suyo, solo de comportamiento estandar del
  // navegador. Antes se miraba `dialog._rsi_main_form_dialog_element[open]`,
  // que era un selector interno de Releasit y podia romperse sin aviso.
  // Si algun dia dejara de usar un <dialog>, salta el timeout y no se cuelga.
  function teluceWaitForForm(cb, maxMs){
    var t0 = Date.now();
    var iv = setInterval(function(){
      var abierto = document.querySelector('dialog[open]');
      if(abierto || (Date.now() - t0) > (maxMs || 9000)){
        clearInterval(iv);
        cb(!!abierto);
      }
    }, 100);
  }

  // host = contenedor del builder en el PDP. En páginas NO-producto no
  // existe — las features GLOBALES (drawer dos estados, badge, indicador,
  // tab Carrito) deben correr igual. host queda null y se guarda cada uso.
  var host=document.getElementById('teluce-mix-match');
  if(host){
    var enabled=host.dataset.mixMatchEnabled==='true' || host.dataset.mixMatchEnabled==='True';
    if(!enabled && host.dataset.mixMatchEnabled) enabled=true;
    var piCheck=document.querySelector('product-info');
    if(piCheck && piCheck.dataset.mixMatchEnabled==='false') enabled=false;
    var pi2=document.querySelector('[data-mix-match-enabled]');
    if(pi2 && pi2.dataset.mixMatchEnabled==='false') enabled=false;
    if(!enabled) host=null; // builder del PDP apagado; lo global sigue
  }
  var KEY='teluce-mix-match';
  if(!window.PUB_SUB_EVENTS) window.PUB_SUB_EVENTS={};
  window.PUB_SUB_EVENTS.mixMatchUpdate=window.PUB_SUB_EVENTS.mixMatchUpdate||'mix-match-update';
  // Tope de prendas del pack. La campana de basicas premia 4 (paga 3) y 6
  // (paga 4), asi que hay que poder elegir hasta 6. Fuente unica: si manana
  // cambia la oferta, se cambia aca y en freeCount().
  var SLOT_MAX=6;
  var Store={
    slots:[null,null,null,null,null,null], step:1, reviewOpen:false,
    load:function(){try{var s=sessionStorage.getItem(KEY);if(s){var p=JSON.parse(s);if(p.slots&&p.slots.length>=3&&p.slots.length<=SLOT_MAX){while(p.slots.length<SLOT_MAX)p.slots.push(null); this.slots=p.slots;}}}catch(e){}},
    save:function(){try{sessionStorage.setItem(KEY,JSON.stringify({slots:this.slots}));}catch(e){}},
    count:function(){return this.slots.filter(Boolean).length;},
    add:function(slot){var idx=this.slots.findIndex(function(s){return !s;}); if(idx===-1) return false; this.slots[idx]=slot; this.save(); if(window.publish) publish(PUB_SUB_EVENTS.mixMatchUpdate,{slots:this.slots}); render(); maybeLoadColors(slot.handle); return true;},
    replace:function(i,slot){ if(i<0||i>=SLOT_MAX||!slot) return false; this.slots[i]=slot; this.save(); if(window.publish) publish(PUB_SUB_EVENTS.mixMatchUpdate,{slots:this.slots}); render(); return true; },
    remove:function(i){
      this.slots[i]=null;
      // COMPACTAR: no importa de cuál slot se quite, las prendas se reacomodan
      // consecutivas desde el primero — nunca quedan huecos (el pill "2
      // blusas" SIEMPRE corresponde a slots 1+2 llenos, sin incongruencia).
      this.slots = this.slots.filter(Boolean);
      while(this.slots.length<SLOT_MAX) this.slots.push(null);
      // al vaciar el pack (0 prendas): limpiar el carrito real — si no, las
      // prendas viejas quedan y Releasit las muestra en el siguiente form
      // (y aparecen precios residuales como el 26.000).
      if(this.slots.filter(Boolean).length===0){
        try{ fetch('/cart/clear.js',{method:'POST'}); }catch(e){}
      }
      this.save(); if(window.publish) publish(PUB_SUB_EVENTS.mixMatchUpdate,{slots:this.slots}); render();
    },
    clear:function(){this.slots=[null,null,null]; this.save(); if(window.publish) publish(PUB_SUB_EVENTS.mixMatchUpdate,{slots:this.slots}); render();}
  };
  Store.load();
  // ponytail: demo assert
  console.assert(Store.slots.length===SLOT_MAX,'mix-match slots SLOT_MAX');
  function getCurrentSlot(){
    var idInput=document.querySelector('input[name="id"]');
    var variantId=idInput? idInput.value:null;
    if(!variantId) return null;
    var pi=document.querySelector('product-info');
    var titleEl=document.querySelector('.product__title h1');
    var title=titleEl? titleEl.textContent.trim():'Producto';
    var vs=document.querySelector('variant-selects');
    var variant=null;
    try{var el=vs&&vs.querySelector('[data-selected-variant]'); if(el) variant=JSON.parse(el.textContent);}catch(e){}
    var price=0;
    if(variant && typeof variant.price==='number') price=variant.price/100;
    else { var pEl=document.querySelector('#price-'+host.dataset.section+' .price-item--last, #price-'+host.dataset.section+' .price-item--regular, .price--large .price-item'); if(pEl){ var t=pEl.textContent.replace(/[^0-9.,]/g,'').replace(/\./g,'').replace(',','.'); price=parseFloat(t)||0; } }
    var handle=(location.pathname.split('/products/')[1]||'').split('/')[0].split('?')[0]||'handle';
    var productId=pi? pi.dataset.productId:'';     var variantTitle=variant? variant.title:'';
    // Color robusto: leer la opción "Color" del DOM (data-option-name). El
    // viejo variantTitle.split('/').pop() fallaba en productos con 2 opciones
    // (Color + Talla): el "Top Ajustado de Cuello Mock" mostraba "Talla única
    // (S-L)" en vez del color porque .pop() agarra el ÚLTIMO segmento.
    var color='';
    try{
      document.querySelectorAll('variant-selects input[data-option-name], variant-selects select option[data-option-name]').forEach(function(el){
        if(color) return;
        if((el.dataset.optionName||'').toLowerCase()==='color'){
          var val=el.tagName==='OPTION' ? (el.selected? el.value:'') : (el.checked? el.value:'');
          if(val) color=val;
        }
      });
    }catch(e){}
    if(!color) color=(variantTitle.split('/').pop()||variantTitle||'Único').trim();
    var image=''; var media=document.querySelector('media-gallery img, .product__media img'); if(media) image=media.currentSrc||media.src||''; if(variant&&variant.featured_media&&variant.featured_media.preview_image) image=variant.featured_media.preview_image.src||image;
    return {variantId:String(variantId),productId:String(productId),handle:handle,title:title,variantTitle:variantTitle,color:color,image:image,price:price};
  }
  function money(n){return '$'+Math.round(n).toLocaleString('es-CO');}
  // Colores por slot: carga las variantes de color del producto (vía .js
  // público) para que el cliente pueda cambiar el color de cada prenda.
  // Colores por slot: mapa de marca (valores reales del admin) para dots
  // sólidos. Los que no estén en el mapa caen a la imagen de la variante.
  // TAXONOMÍA CANÓNICA DE COLORES — nombre canónico en español + alias
  // (valores reales de las variantes, en español e inglés) → hex + display.
  // El builder normaliza cualquier valor de variante a su color canónico.
  var COLOR_TAXONOMY={
    'amarillo':        {hex:'#FFE500', alias:['amarillo','yellow']},
    'azul':            {hex:'#005BD3', alias:['azul','blue']},
    'azul grisáceo':   {hex:'#6E7B8B', alias:['azul grisáceo','azul grisaceo','slate blue','blue gray','blue grey','gris azulado']},
    'beige':           {hex:'#EAD8AB', alias:['beige','beis','tan']},
    'beige terracota': {hex:'#D9A08A', alias:['beige terracota','beige terracota','terracota beige','gold','dorado']},
    'blanco':          {hex:'#FFFFFF', alias:['blanco','blanca','white','ivory','marfil','clara','clear']},
    'marrón':          {hex:'#9A5630', alias:['marrón','marron','brown','café','cafe','chocolate']},
    'marrón claro':    {hex:'#B08D6A', alias:['marrón claro','marron claro','light brown','lightbrown','café claro','cafe claro']},
    'claro':           {hex:'#E8DCC8', alias:['claro','light','crema','cream']},
    'fucsia':          {hex:'#D5006D', alias:['fucsia','fuscia','fuchsia','magenta']},
    'gris':            {hex:'#748A9E', alias:['gris','gray','grey']},
    'negro':           {hex:'#000000', alias:['negro','black']},
    'rosa':            {hex:'#FFC0CB', alias:['rosa','pink','rosado','rosado claro']},
    'rojo':            {hex:'#F61F1F', alias:['rojo','red']},
    'caramelo':        {hex:'#C19A74', alias:['caramelo','caramel']},
    'terracota':       {hex:'#B4552D', alias:['terracota','terracotta']}
  };
  function normalizeColor(name){
    if(!name) return {hex:'', display:''};
    var n=String(name).toLowerCase().trim().replace(/\s+/g,' ');
    for(var k in COLOR_TAXONOMY){
      if(COLOR_TAXONOMY[k].alias.indexOf(n)!==-1){
        return {hex:COLOR_TAXONOMY[k].hex, display:k};
      }
    }
    return {hex:'', display:String(name)};
  }
  function colorHex(name){ return normalizeColor(name).hex; }
  function altColorKey(s){ return String(s||'').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-z0-9]/g,''); }
  // canónico de un color/alt via la taxonomía (MARRON_CLARO, Light brown,
  // marrón claro → 'marrón claro'; PINK, Rosa → 'rosa')
  var _canonLookup=null;
  function canonKey(name){
    if(!name) return '';
    var n=altColorKey(name);
    if(!_canonLookup){
      _canonLookup={};
      for(var k in COLOR_TAXONOMY){
        COLOR_TAXONOMY[k].alias.forEach(function(a){ _canonLookup[altColorKey(a)]=k; });
      }
    }
    return _canonLookup[n] || n;
  }
  var productVariantsCache={};
  try{ productVariantsCache=JSON.parse(sessionStorage.getItem('teluce-colors-v2')||'{}'); }catch(e){}
  // timestamps por handle: el cache de sessionStorage puede quedar STALE si
  // el inventario cambió en admin mientras la pestaña seguía abierta (los
  // colores nuevos no aparecían ni en dots ni en slots del builder — parecía
  // hardcodeado). Expiración de 10 min + refresh forzado en cada load de
  // página del handle actual.
  var cacheTS={};
  try{ cacheTS=JSON.parse(sessionStorage.getItem('teluce-colors-v2-ts')||'{}'); }catch(e){}
  function persistColorCache(){
    try{ sessionStorage.setItem('teluce-colors-v2', JSON.stringify(productVariantsCache)); }catch(e){}
    try{ sessionStorage.setItem('teluce-colors-v2-ts', JSON.stringify(cacheTS)); }catch(e){}
  }
  function extractColors(data){
    var opts=data&&data.options||[];
    var ci=0;
    for(var k=0;k<opts.length;k++){ if(/color/i.test(opts[k].name||'')){ ci=k; break; } }
    var fallback=(data&&data.featured_image)||'';
    // mapa canónico -> PRIMERA foto del color ([COLOR]_1) desde los alts de
    // la media: el dot y el slot muestran la blusa de referencia del color
    var colorImg={};
    // mapa canónico -> TODAS las fotos del color (orden de la media): lo usa
    // el carrusel del hero-pack del catálogo para navegar las fotos sin PDP.
    var colorPhotos={};
    var colorVideos={}; // map canonico -> VIDEOS del color (alt "[COLOR]_video_N")
    try{
      (data.media||[]).forEach(function(m){
        if(!m.alt) return;
        var alt=String(m.alt);
        var isVideo=/video/i.test(alt);
        var key=canonKey(alt.replace(/_video_\d+$/,'').replace(/_\d+$/,''));
        if(!key) return;
        var src=m.src||(m.preview_image&&m.preview_image.src)||'';
        // VIDEOS: la URL real está en m.sources (el .mp4 de cdn.shopify.com/
        // videos/...) — m.src es null y m.preview_image es un JPG thumbnail
        // que el <video> no puede reproducir.
        if(isVideo && m.sources && m.sources.length){
          src=m.sources.map(function(s){ return s&&s.url? s.url : s; }).filter(Boolean)[0];
        }
        if(!src) return;
        if(isVideo){
          (colorVideos[key]=colorVideos[key]||[]).push(src);
        } else {
          if(!colorImg[key]) colorImg[key]=src;
          (colorPhotos[key]=colorPhotos[key]||[]).push(src);
        }
      });
    }catch(e){}
    return (data&&data.variants||[]).map(function(v){
      var col=(v.options&&v.options[ci])||v.title||'';
      var key=canonKey(col);
      var img=colorImg[key] || v.featured_image || fallback;
      var photos=colorPhotos[key]||[];
      if(!photos.length && img) photos=[img];
      return {id:v.id, color:col, img:img, photos:photos, videos:colorVideos[key]||[], price:typeof v.price==='number'? v.price/100 : 0, available:v.available!==false};
    }).filter(function(v){ return v.color && v.available; });
  }
  function maybeLoadColors(handle){
    if(!handle) return;
    var ts=cacheTS[handle]||0;
    // fresco (<10 min) → usar cache; si no, re-fetch (inventario pudo cambiar)
    if(productVariantsCache[handle] && (Date.now()-ts) < 600000) return;
    fetch('/products/'+handle+'.js').then(function(r){return r.json();}).then(function(d){
      productVariantsCache[handle]=extractColors(d);
      cacheTS[handle]=Date.now();
      persistColorCache();
      render();
    }).catch(function(){});
  }
  // ============================================================
  // HERO-PACK DEL CATÁLOGO (sections/teluce-pack-catalog): el ancla de la
  // promesa "tú eliges cómo armas tu pack". Pills de tiers + slots de
  // progreso + las 3 referencias en plano con dots de color. Alimenta el
  // MISMO Store que el drawer (window.TeluceMixMatchStore) — el estado vive
  // en sesión y el drawer lo refleja al abrir.
  // ============================================================
  var activeRefIdx=0;
  function updateRefMax(){
    var max=Store.count()>=SLOT_MAX;
    document.querySelectorAll('.teluce-pack-catalog__ref').forEach(function(ref){
      var btn=ref.querySelector('[data-ref-add]');
      var mx=ref.querySelector('[data-ref-max]');
      if(btn) btn.hidden=max;
      if(mx) mx.hidden=!max;
    });
  }
  function initPackCatalog(){
    updateRefMax(); // estado inicial (Store puede venir con 3 persistido)
    var root=document.getElementById('teluce-pack-catalog');
    if(!root) return;
    teluceTrack('pack_view', {refs: document.querySelectorAll('.teluce-pack-catalog__ref').length});
    var slotsEl=root.querySelector('#teluce-pack-catalog-slots');
    var headEl=root.querySelector('[data-pack-head]');
    var titleEl=root.querySelector('[data-catalog-title]');
    var subEl=root.querySelector('[data-catalog-sub]');
    var subBase=subEl?subEl.textContent:'';
    var refs=[].slice.call(root.querySelectorAll('.teluce-pack-catalog__ref'));
    if(!refs.length) return;
    var state={};
    refs.forEach(function(ref){
      state[ref.getAttribute('data-handle')]={selected:null, variants:[], photoIdx:0, infoActive:null};
    });
    // VISIBILIDAD: SOLO el video de la prenda MÁS visible reproduce; el resto
    // se pausa. Así, al mirar/ver otra prenda, el video anterior deja de
    // reproducirse (no queda corriendo fuera de foco). Evita N videos en loop
    // (rendimiento/batería/datos).
    if('IntersectionObserver' in window){
      var _vidRatios=new Map();
      var _playingRef=null; // ref cuyo video está en foco
      function _syncVideos(){
        // el "mejor" es la prenda con video VISIBLE más en foco (ratio mayor)
        var best=null, bestR=0;
        _vidRatios.forEach(function(r, ref){
          var v=ref.querySelector('[data-ref-video]');
          if(!v || v.hidden) return; // solo cuentan videos visibles
          if(r>bestR){ bestR=r; best=ref; }
        });
        refs.forEach(function(ref){
          var video=ref.querySelector('[data-ref-video]');
          if(!video || video.hidden) return;
          if(ref===best && bestR>=0.5){
            ref._visible=true;
            // AL RE-ENFOCAR una prenda distinta: reiniciar desde el inicio
            if(_playingRef!==ref){
              try{ video.currentTime=0; }catch(e){}
              _playingRef=ref;
            }
            try{ video.play(); }catch(e){}
          } else {
            ref._visible=false;
            try{ video.pause(); }catch(e){}
          }
        });
        if(!best) _playingRef=null;
      }
      var vidIO=new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          _vidRatios.set(en.target, en.isIntersecting ? en.intersectionRatio : 0);
        });
        _syncVideos();
      },{ threshold:[0, .25, .5, .75, 1] });
      refs.forEach(function(ref){ vidIO.observe(ref); });
    }
    // head storytelling (Knaflic): mensaje según el avance del pack
    var CATALOG_HEAD=[
      // MOBILE. Espejo del CATALOG_HERO (desktop): los dos bloques son
      // mutuamente excluyentes por CSS (hero-desk se oculta ≤749px, head se
      // oculta ≥750px) → TIENEN que decir lo mismo o un breakpoint queda mudo.
      // Copy SIN "pack" y SIN invitar al plural con 0 prendas: una prenda es
      // una compra válida; el descuento es consecuencia de sumar, no requisito.
      // 7 estados (0-6 basicas). k = kicker (la emocion, FIJA por estado);
      // m = mensaje principal (la jugada). m2 = segunda jugada, opcional: cuando
      // existe, ALTERNA con m mientras la clienta sigue en ese estado. El kicker
      // no rota: es lo que da sensacion de avance al cambiar de estado.
      // Tuteo colombiano. "basica", no "prenda".
      {k:'Tú eliges cómo lucir',              m:'Que las básicas te acompañen toda la semana'},
      {k:'Ya tienes tu 1era básica para lucirla como antojes',
                                              m:'Puedes llevarte 4 y pagas solo 3',
                                              m2:'o si piensas para toda la semana, llévate 6 y pagas 4'},
      {k:'Esa básica sí que te va a lucir',   m:'Una más y vas a poder llevarte la 4ta gratis'},
      {k:'Eso es querer lucir a lo grande',   m:'Llévate gratis la 4ta, solo pagas estas 3'},
      {k:'Por estilo ya no te varas la siguiente semana',
                                              m:'Elige 2 más y pagas solo estas 4'},
      {k:'Listo, de Lunes a Viernes estilo va a estar de sobra',
                                              m:'Con la 6ta nos alcanza hasta el sábado'},
      {k:'LISTO! El sábado sí que más te mereces estrenar',
                                              m:'Te llevas 6 básicas hermosas y solo pagas 4'}
    ];
    // TITULAR dinámico. En 0 prendas NO se invita a "elegir varias" (ese era el
    // problema): es mood, no tarea. El encuadre de pack aparece recién cuando ya
    // hay una prenda elegida — ahí sí es una invitación, no una presuposición.
    var CATALOG_HERO=[
      {t:'TÚ ELIGES CÓMO LUCIR',     s:'Que las básicas te acompañen toda la semana'},
      {t:'YA TIENES TU 1ERA BÁSICA', s:'Puedes llevarte 4 y pagas solo 3'},
      {t:'ESA BÁSICA TE VA A LUCIR', s:'Una más y te llevas la 4ta gratis'},
      {t:'ESO ES QUERER LUCIR A LO GRANDE', s:'Llévate gratis la 4ta, solo pagas estas 3'},
      {t:'POR ESTILO YA NO TE VARAS', s:'Elige 2 más y pagas solo estas 4'},
      {t:'DE LUNES A VIERNES LISTO',  s:'Con la 6ta nos alcanza hasta el sábado'},
      {t:'¡LISTO! EL SÁBADO ESTRENAS', s:'Te llevas 6 básicas hermosas y solo pagas 4'}
    ];
    function renderHero(c){
      if(!titleEl) return;
      var h=CATALOG_HERO[c]||CATALOG_HERO[0];
      if(titleEl.textContent!==h.t) titleEl.textContent=h.t;
      if(subEl) subEl.textContent=h.s||subBase;
    }
    var packLastCount=-1;
    function segsOf(html){
      var segs=[], tmp=document.createElement('div'); tmp.innerHTML=html;
      Array.prototype.slice.call(tmp.childNodes).forEach(function(n){
        if(n.nodeType===3) segs.push({plain:n.nodeValue||'', html:n.nodeValue||''});
        else segs.push({plain:n.textContent||'', html:n.outerHTML||''});
      });
      return segs;
    }
    function typeHeadOnce(s){
      if(!headEl) return;
      if(window.matchMedia('(prefers-reduced-motion: reduce)').matches){
        headEl.innerHTML='<p class="tl-kicker">'+s.k+'</p><p class="tl-main">'+s.m+'</p>';
        return;
      }
      headEl.innerHTML='';
      var k=document.createElement('p'); k.className='tl-kicker';
      var m=document.createElement('p'); m.className='tl-main';
      headEl.appendChild(k); headEl.appendChild(m);
      k.textContent=s.k; m.innerHTML=s.m;
      headEl.style.minHeight=headEl.offsetHeight+'px';
      k.textContent=''; m.innerHTML='';
      var ki=0;
      (function tickK(){
        if(ki<=s.k.length){ k.textContent=s.k.slice(0,ki); ki++; setTimeout(tickK,20); }
        else setTimeout(tickM,180);
      })();
      var segs=segsOf(s.m), mi=0;
      function mlen(){ var n=0; segs.forEach(function(x){n+=x.plain.length;}); return n; }
      function renderM(i){ var out='',rem=i; for(var x=0;x<segs.length&&rem>0;x++){ var take=Math.min(rem,segs[x].plain.length); out+= take===segs[x].plain.length?segs[x].html:segs[x].plain.slice(0,take); rem-=take; } return out; }
      function tickM(){ if(mi<=mlen()){ m.innerHTML=renderM(mi); mi++; setTimeout(tickM,22); } }
    }
    var headRotTimer=null;
    function renderHead(c){
      // DESACTIVADO: el head es ESTATICO (orienta, no acompana). El
      // acompanamiento por estado vive en la fila de descuento del drawer.
      if(true) return;
      renderHero(c);
      if(!headEl) return;
      var s=CATALOG_HEAD[c]||CATALOG_HEAD[0];
      var sig=s.k+'|'+s.m;
      if(headEl._sig===sig) return;
      headEl._sig=sig;
      // Se limpia SIEMPRE antes de re-armar: si no, cada cambio de estado
      // deja un intervalo vivo y el head empieza a parpadear.
      if(headRotTimer){ clearInterval(headRotTimer); headRotTimer=null; }
      typeHeadOnce(s);
      // ROTACION de la segunda jugada (m2). Alterna con m mientras la clienta
      // sigue en ese estado. 4.5s: las sesiones son cortas y la atencion es lo
      // mas escaso. El KICKER no rota a proposito: es lo que da sensacion de
      // avance cuando cambia de estado, y re-tipearlo cada ciclo seria un
      // parpadeo. Solo se cambia el elemento del mensaje, sin re-escribir.
      if(s.m2){
        var vals=[s.m, s.m2], ri=0;
        headRotTimer=setInterval(function(){
          var mainEl=headEl.querySelector('.tl-main');
          if(!mainEl) return;
          ri=(ri+1)%vals.length;
          mainEl.innerHTML=vals[ri];
          mainEl.classList.remove('tl-rot');
          void mainEl.offsetWidth;   // reflow: reinicia la animacion
          mainEl.classList.add('tl-rot');
        }, 4500);
      }
    }
    // ============================================================
    // DRAWER DEL PACK (CATALOGO) — render.
    // Lee Store.slots y arma las filas: imagen del color elegido, NOMBRE de la
    // blusa, swatches de colores disponibles y boton de quitar.
    // Los colores salen de productVariantsCache[handle] — el mismo cache que
    // alimenta los dots del catalogo; si falta, maybeLoadColors lo pide.
    // Es el drawer PROPIO del catalogo: no comparte nada con el del PDP.
    // ============================================================
    function renderCatDrawer(){
      var cdRoot=document.getElementById('TeluceCatalogDrawer');
      if(!cdRoot) return;
      var listEl=cdRoot.querySelector('[data-cat-drawer-list]');
      var totalEl=cdRoot.querySelector('[data-cat-drawer-total]');
      var titleEl=cdRoot.querySelector('[data-cat-drawer-title]');
      var subEl=cdRoot.querySelector('[data-cat-drawer-subtotal]');
      var discRow=cdRoot.querySelector('[data-cat-drawer-discrow]');
      var discVal=cdRoot.querySelector('[data-cat-drawer-discval]');
      var filled=Store.slots.filter(Boolean);
      var c=filled.length;
      // Mismo idioma que el drawer del PDP (que ya dice 'Selecciona tus colores').
      if(titleEl) titleEl.textContent = c===1 ? 'Selecciona tu color' : 'Selecciona tus colores';
      // "Revisa tu pack de N basicas": el conteo lo conoce el render, no el
      // markup estatico. Singular/plural segun corresponda.
      var headCount=document.querySelector('[data-cat-head-count]');
      if(headCount) headCount.textContent = c>0 ? ' de '+c+(c===1?' básica':' básicas') : '';
      var catLibres = (window.TelucePackMath ? window.TelucePackMath.freeCount() : 0);
      if(listEl){
        listEl.innerHTML = filled.map(function(s,pos){
          // INDICE ABSOLUTO, no el del array filtrado: filter() corre las
          // posiciones y Store.remove(i) borraria la prenda de al lado.
          var idx=Store.slots.indexOf(s);
          var colores=productVariantsCache[s.handle]||[];
          var swat=colores.map(function(cv){
            var act=String(cv.id)===String(s.variantId);
            var hex=colorHex(cv.color);
            var bg=cv.img? 'background-image:url('+cv.img+');background-size:cover;background-position:center'
                         : (hex? 'background:'+hex : '');
            var nom=String(cv.color).replace(/"/g,'&quot;');
            return '<button type="button" class="teluce-cat-drawer__swatch'+(act?' is-active':'')+'"'+
              ' data-cat-swatch="'+idx+'" data-cat-variant="'+cv.id+'" title="'+nom+'" aria-label="'+nom+'"'+
              (act?' aria-current="true"':'')+' style="'+bg+'"></button>';
          }).join('');
          var nm=String(s.title||'Básica').replace(/"/g,'&quot;');
          // GRATIS en los ULTIMOS catLibres: la pill marca lo que no se paga,
          // y lo que no se paga son las ultimas (con 4 la 4ta, con 6 la 5ta y
          // la 6ta). Misma regla que ya usa el catalogo en los slots.
          var esGratis = pos >= (c - catLibres);
          return '<div class="teluce-cat-drawer__item'+(esGratis?' is-free':'')+'">'+
            // Miniatura y pill en el MISMO contenedor flex en columna, centrado
            // y anclado abajo. Asi la pill va en el flujo (nada de absolute) y
            // queda debajo de la miniatura sin poder desbordar nada.
            '<div class="teluce-cat-drawer__thumb">'+
              '<img class="teluce-cat-drawer__img" src="'+(s.image||'')+'" alt="" loading="lazy">'+
              (esGratis? '<span class="teluce-cat-drawer__free">GRATIS</span>' : '')+
            '</div>'+
            '<div class="teluce-cat-drawer__meta">'+
              '<span class="teluce-cat-drawer__name">'+nm+'</span>'+
              '<span class="teluce-cat-drawer__color">'+normalizeColor(s.color).display+'</span>'+
              (swat? '<div class="teluce-cat-drawer__swatches">'+swat+'</div>' : '')+
            '</div>'+
            '<button type="button" class="teluce-cat-drawer__remove" data-cat-remove="'+idx+'"'+
            ' aria-label="Quitar '+nm+'">✕</button>'+
          '</div>';
        }).join('') +
        // Invitacion a la 4ta: ocupa su lugar en la fila cuando hay 3. Es una
        // celda mas, no un aviso aparte: se lee como 'aca va la que te falta'.
        (function(){
          // Misma regla que el chip fantasma y la franja: aparece cuando agregar
          // UNA MAS desbloquea prenda(s) gratis. Da 3 y 5.
          var f=window.TelucePackMath&&window.TelucePackMath.freeFor;
          if(!f) return '';
          // TOTAL de gratis que tendras con la proxima, no la diferencia: con
          // 3 son 1, con 5 son 2. Misma formula que la franja — tener dos
          // distintas para el mismo dato fue justo lo que fallo aca.
          var nPremios=f(c+1);
          if(nPremios<=0) return '';
          // Redaccion propia del drawer (no la de la franja): su registro es
          // "Llevate gratis la Nta / solo pagas estas N". El copy de la 6ta sale
          // de esa misma estructura, no de una frase nueva.
          var main = c===3? 'Llévate gratis la 4ta' : (c===5? 'Llévate gratis la 6ta' : '');
          var sub  = c===3? 'solo pagas estas 3'    : (c===5? 'solo pagas estas 4'    : '');
          if(!main) return '';
          var g=(window.TelucePackMath&&window.TelucePackMath.gift)||'';
          var sello=''; for(var i=0;i<nPremios;i++) sello+=g+' ';
          return '<div class="teluce-cat-drawer__invite">'+
              '<span class="teluce-cat-drawer__invite-main">'+sello+main+'</span>'+
              '<span class="teluce-cat-drawer__invite-sub">'+sub+'</span>'+
            '</div>';
        })();
      }
      // DESGLOSE: subtotal (suma de las prendas) / descuento / total.
      // El descuento sale de la matematica que ya existe: subtotal - total.
      var sumaPre = filled.reduce(function(acc,x){ return acc + (x.price||0); }, 0);
      var tot = (c===1) ? (filled[0]?filled[0].price:0)
                        : (window.TelucePackMath ? window.TelucePackMath.bundlePrice() : sumaPre);
      var desc = Math.max(0, sumaPre - tot);
      if(subEl) subEl.textContent = money(sumaPre);
      if(totalEl) totalEl.textContent = money(tot);
      if(discRow){
        // dos trabajos: invita cuando es 0, muestra el ahorro cuando aplica
        discRow.classList.toggle('is-active', desc > 0);
        // 1 y 2: sin rodeos, $0. La invitacion aparece SOLO con 3, que es cuando el
        // premio esta a una prenda de distancia y el empujon tiene sentido.
        if(discVal) discVal.textContent = desc > 0 ? ('−' + money(desc))
                                                  : (c===3 ? 'Elige GRATIS una 4ta' : money(0));
      }
      // color que falte -> pedirlo; maybeLoadColors re-renderiza al llegar
      filled.forEach(function(s){ if(!productVariantsCache[s.handle]) maybeLoadColors(s.handle); });
    }

    // Confirmar y cerrar desde ADENTRO del drawer. El confirm dispara el mismo
    // [data-pack-confirm] que usaba el CTA: la logica de compra no se duplica.
    (function(){
      var cdRoot=document.getElementById('TeluceCatalogDrawer');
      if(!cdRoot) return;
      cdRoot.addEventListener('click', function(e){
        if(!e.target.closest('[data-cat-drawer-confirm]')) return;
        var lbl=cdRoot.querySelector('.teluce-cat-drawer__confirm-label');
        var cta=cdRoot.querySelector('[data-cat-drawer-confirm]');
        var SY=window.TelucePackSync;
        if(!SY || typeof SY.run!=='function'){
          if(lbl) lbl.textContent='No pudimos abrir el pedido. Intenta de nuevo.';
          return;
        }
        function finCarga(){
          if(lbl) lbl.textContent='Confirmar pedido';
          if(cta){ cta.classList.remove('is-loading'); cta.disabled=false; cta.removeAttribute('aria-busy'); }
        }
        cta.classList.add('is-loading');
        cta.disabled=true;
        cta.setAttribute('aria-busy','true');
        if(lbl) lbl.textContent='Preparando tu pack';
        // El listener de cart-drawer.js abre el drawer LEGACY como respaldo
        // cuando ve el evento del pack, y consulta ESTA bandera antes de hacerlo.
        // Aca ya tenemos el camino bueno (Releasit), asi que se marca: sin drawer
        // legacy parpadeando detras ni quedando visible al cerrar Releasit.
        window.__telucePackRedirected=true;
        // MISMA ruta que el buybar estable, que es la que SI llega a Releasit:
        // sync sin recarga -> el boton propio de Releasit -> esperar su form.
        // addPack recargaba, y la recarga abria el drawer legacy (paracaidas).
        SY.run().then(function(ok){
          if(!ok){ finCarga(); return; }
          var rsi=document.getElementById('rsi_buy_now_button');
          if(rsi){ rsi.click(); }
          // el boton se suelta cuando el dialog de Releasit esta EN PANTALLA,
          // no antes: si no, el spinner se apaga justo durante la espera.
          teluceWaitForForm(function(){ finCarga(); });
        }).catch(function(){ finCarga(); });
      });
      var closeBtn=cdRoot.querySelector('[data-cat-drawer-close]');
      if(closeBtn) closeBtn.addEventListener('click', function(){
        if(typeof cdRoot.hide==='function') cdRoot.hide(); else cdRoot.removeAttribute('open');
      });
    })();

    // El render vive en ESTE IIFE, pero lo llama la barra, que vive en otro.
    // Se expone con el mismo patron que el proyecto ya usa (window.Teluce*).
    window.TeluceCatDrawer = { render: renderCatDrawer };

    // Interacciones del drawer: cambiar color y quitar. Delegado en el root,
    // asi sobrevive a cualquier re-render de la lista.
    (function(){
      var cdRoot=document.getElementById('TeluceCatalogDrawer');
      if(!cdRoot) return;
      cdRoot.addEventListener('click', function(e){
        var sw=e.target.closest('[data-cat-swatch]');
        if(sw){
          var i=parseInt(sw.getAttribute('data-cat-swatch'),10);
          var s=Store.slots[i];
          if(!s) return;
          var colores=productVariantsCache[s.handle]||[];
          for(var k=0;k<colores.length;k++){
            if(String(colores[k].id)===String(sw.getAttribute('data-cat-variant'))){
              var cv=colores[k];
              // try: Store.replace guarda los datos y DESPUES llama a un
              // render() que no existe en su scope, asi que lanza. El dato ya
              // quedo bien; solo se pierde el repintado.
              try{
              // Store.replace reusa toda la logica del pack: persiste, publica
              // el evento y re-renderiza. El color es lo unico que cambia.
              Store.replace(i, {variantId:String(cv.id), productId:s.productId, handle:s.handle,
                title:s.title, variantTitle:cv.color, color:cv.color,
                image:cv.img||'', price:cv.price||s.price||0});
              }catch(err){}
              // repintado inmediato, sin cerrar y reabrir
              if(window.TeluceCatDrawer) window.TeluceCatDrawer.render();
              teluceTrack('cat_drawer_color', {handle:s.handle, color:cv.color});
              return;
            }
          }
          return;
        }
        var rm=e.target.closest('[data-cat-remove]');
        if(rm){
          // mismo caso: try + repintado a mano
          try{ Store.remove(parseInt(rm.getAttribute('data-cat-remove'),10)); }catch(err){}
          if(window.TeluceCatDrawer) window.TeluceCatDrawer.render();
          teluceTrack('cat_drawer_remove', {count:Store.count()});
        }
      });
    })();

    function renderSlots(){
      if(!slotsEl) return;
      var isMobile=window.matchMedia('(max-width: 749px)').matches;
      var c=Store.count();
      // pills row del DESKTOP (hero) — activo el tier alcanzado
      var pillRow=root.querySelector('[data-pills-desk]');
      if(pillRow){
        [].slice.call(pillRow.querySelectorAll('[data-pill]')).forEach(function(pill){
          var n=parseInt(pill.getAttribute('data-pill'),10);
          pill.classList.toggle('is-active', c>=3? n===3 : n===Math.min(2,Math.max(1,c+1)));
        });
      }
      // cada columna: [1ª prenda] ARRIBA · [slot] al medio · [pill] abajo
      var POS=['1ª básica','2ª básica','3ª básica','4ª básica','5ª básica','6ª básica'];
      var html=Store.slots.map(function(s,i){
        // En unidades, no en %: la oferta se dice "lleva 4 paga 3".
        // QUE slot es GRATIS: los ULTIMOS freeCount() de los elegidos. NO es
        // acumulativo por indice: con 5 basicas sigue habiendo UNA gratis y es
        // la 5TA — la 4ta dejo de serlo al sumar la quinta. Con 6 son las 2
        // ultimas, doradas las dos. La pill marca lo que no se paga, y lo que
        // no se paga son las ultimas.
        var libres=freeCount();
        var esGratis=(i<c) && (i>=(c-libres));
        var tierValue=esGratis? 'GRATIS' : 'Full';
        var tierFree=esGratis? ' teluce-pack-tier--free' : '';
        var tierCls=i===0?' teluce-pack-tier--1':(i===2?' teluce-pack-tier--x3':'');
        var activeTier=c===0?1:c;
        var tierActive=(i+1)===activeTier;
        // SIN copy de "X prenda / Full": cuando el tramo no tiene beneficio, la
        // pill no existe. Decir "precio full" es vender en contra.
        var tierHtml= esGratis
          ? '<span class="teluce-pack-tier'+tierCls+tierFree+(tierActive?' is-active':'')+'"><span class="teluce-pack-tier__value">'+tierValue+'</span></span>'
          : '';
        var posHtml='<span class="teluce-pack-catalog__col-pos">'+POS[i]+'</span>';
        var slotHtml;
        if(s){
          if(isMobile){
            var disp=normalizeColor(s.color).display;
            slotHtml='<div class="teluce-pack-catalog__col">'+posHtml+'<div class="teluce-pack-catalog__circle-wrap"><div class="teluce-pack-catalog__circle is-filled" title="'+String(disp).replace(/"/g,'&quot;')+'"><img src="'+s.image+'" alt=""></div><button data-slot-remove="'+i+'" class="teluce-pack-catalog__circle-remove" aria-label="Quitar del pack">✕</button></div>'+tierHtml+'</div>';
          } else {
            slotHtml='<div class="teluce-pack-catalog__col">'+posHtml+'<div class="teluce-pack-slot is-filled"><img src="'+s.image+'" alt=""><div class="teluce-pack-slot__meta"><strong>'+s.title+'</strong><span>'+normalizeColor(s.color).display+'</span></div><button data-slot-remove="'+i+'" class="teluce-pack-catalog__slot-remove" aria-label="Quitar del pack">✕</button></div>'+tierHtml+'</div>';
          }
        } else {
          // La campana arranca SIN slots vacios: el "+" era un placeholder que
          // ensuciaba el arranque. Un slot aparece por cada prenda agregada.
          return '';
        }
        return slotHtml;
      }).join('');
      slotsEl.innerHTML=html;
      // Confeti al llegar a la CUARTA basica: es el tramo que desbloquea el
      // premio. Antes disparaba en 2 y 3, que ya no dan nada.
      if(c>packLastCount && c===4){
        var col=slotsEl.querySelectorAll('.teluce-pack-catalog__col')[c-1];
        var pill=col&&col.querySelector('.teluce-pack-tier');
        if(pill) spawnConfetti(pill);
      }
      packLastCount=c;
    }
    // slides del color: los VIDEOS primero (la modelo en movimiento, impacto
    // inmediato) y después las fotos. Solo si el color tiene video.
    function slidesOf(st){
      var v=st.selected;
      if(!v) return [];
      var slides=[];
      (v.videos||[]).forEach(function(src){ slides.push({type:'video', src:src}); });
      (v.photos||[]).forEach(function(src){ slides.push({type:'img', src:src}); });
      if(!slides.length && v.img) slides.push({type:'img', src:v.img});
      return slides;
    }
    function renderMedia(ref){
      var handle=ref.getAttribute('data-handle');
      var st=state[handle];
      var img=ref.querySelector('[data-ref-img]');
      var video=ref.querySelector('[data-ref-video]');
      var count=ref.querySelector('[data-ref-count]');
      if(!img || !st.selected) return;
      var slides=slidesOf(st);
      var idx=Math.min(st.photoIdx||0, Math.max(0, slides.length-1));
      var slide=slides[idx];
      if(slide){
        if(slide.type==='video'){
          video.hidden=false;
          img.style.opacity='0';
          img.removeAttribute('src'); // detener la foto
          video.muted=true;
          video.loop=true;
          video.playsInline=true;
          // solo cargar/play si la prenda está VISIBLE (si no, se reproduce
          // al entrar al viewport via el IntersectionObserver)
          if(ref._visible!==false){
            if(video.getAttribute('src')!==slide.src) video.src=slide.src;
            try{ video.play(); }catch(e){}
          } else if(video.getAttribute('src')!==slide.src){
            video.src=slide.src;
          }
        } else {
          video.hidden=true;
          try{ video.pause(); }catch(e){}
          video.removeAttribute('src');
          img.style.opacity='1';
          img.src=slide.src;
        }
      }
      if(count) count.textContent=(idx+1)+'/'+(slides.length||1);
    }
    function renderDots(ref){
      var handle=ref.getAttribute('data-handle');
      var st=state[handle];
      var box=ref.querySelector('[data-ref-dots]');
      if(!box) return;
      if(!st.variants.length){ box.innerHTML=''; return; }
      var ordered=st.variants.slice().reverse();
      box.innerHTML=ordered.map(function(v){
        var hex=colorHex(v.color);
        var style=v.img? 'background-image:url('+v.img+');background-size:cover;background-position:center' : (hex? 'background:'+hex : '');
        var active=st.selected && String(st.selected.id)===String(v.id);
        return '<button type="button" class="teluce-pack-catalog__dot'+(active?' is-active':'')+'" data-ref-color="'+v.id+'" style="'+style+'" title="'+String(v.color).replace(/"/g,'&quot;')+'"></button>';
      }).join('');
      renderMedia(ref);
    }
    function crossfade(ref){
      var img=ref.querySelector('[data-ref-img]');
      if(!img) return;
      // si el slide actual es video, renderMedia lo maneja directo (sin fade)
      var st=state[ref.getAttribute('data-handle')];
      var slides=slidesOf(st);
      var slide=slides[Math.min(st.photoIdx||0, slides.length-1)];
      if(slide && slide.type==='video'){ renderMedia(ref); return; }
      img.style.transition='opacity .4s ease';
      img.style.opacity='0';
      setTimeout(function(){
        renderMedia(ref);
        img.style.opacity='1';
      }, 200);
    }
    function loadRef(ref){
      var handle=ref.getAttribute('data-handle');
      if(window.teluceGetVariants) window.teluceGetVariants(handle).then(function(variants){
        state[handle].variants=variants||[];
        if(!state[handle].selected && variants.length) state[handle].selected=variants[0];
        renderDots(ref);
        renderMedia(ref);
      });
    }
    root.addEventListener('click', function(e){
      var infoOpen=e.target.closest('[data-info-open]');
      if(infoOpen){
        var ref=infoOpen.closest('.teluce-pack-catalog__ref');
        var handle=ref.getAttribute('data-handle');
        var st=state[handle];
        var panel=ref.querySelector('[data-info-panel]');
        if(!panel) return;
        st.infoActive = !st.infoActive;
        panel.hidden = !st.infoActive;
        infoOpen.classList.toggle('is-active', st.infoActive);
        return;
      }
      var infoClose=e.target.closest('[data-info-close]');
      if(infoClose){
        var ref=infoClose.closest('.teluce-pack-catalog__ref');
        var handle=ref.getAttribute('data-handle');
        var st=state[handle];
        var panel=ref.querySelector('[data-info-panel]');
        if(!panel) return;
        st.infoActive=false;
        panel.hidden=true;
        ref.querySelector('[data-info-open]').classList.remove('is-active');
        return;
      }
      var rm=e.target.closest('[data-slot-remove]');
      if(rm){ Store.remove(parseInt(rm.getAttribute('data-slot-remove'),10)); return; }
      var play=e.target.closest('[data-ref-play]');
      if(play){
        var ref=play.closest('.teluce-pack-catalog__ref');
        var handle=ref.getAttribute('data-handle');
        var st=state[handle];
        st.playing=!st.playing;
        play.classList.toggle('is-playing', st.playing);
        play.setAttribute('aria-pressed', st.playing?'true':'false');
        var img=ref.querySelector('[data-ref-img]');
        if(img) img.classList.toggle('teluce-kenburns', st.playing);
        if(st.playing){
          st.playTimer=setInterval(function(){
            var len=slidesOf(st).length||1;
            st.photoIdx=(st.photoIdx||0)+1; if(st.photoIdx>=len) st.photoIdx=0;
            crossfade(ref);
          }, 3000);
        } else {
          if(st.playTimer){ clearInterval(st.playTimer); st.playTimer=null; }
        }
        return;
      }
      var dot=e.target.closest('[data-ref-color]');      var dot=e.target.closest('[data-ref-color]');
      if(dot){
        var ref=dot.closest('.teluce-pack-catalog__ref');
        var handle=ref.getAttribute('data-handle');
        var st=state[handle];
        var vid=dot.getAttribute('data-ref-color');
        for(var q=0;q<st.variants.length;q++){ if(String(st.variants[q].id)===String(vid)){ st.selected=st.variants[q]; break; } }
        st.photoIdx=0;
        renderDots(ref);
        renderMedia(ref);
        teluceTrack('color_select', {handle: handle, color: (st.selected && st.selected.color) || ''});
        return;
      }
      var prev=e.target.closest('[data-ref-prev]');
      if(prev){
        var ref=prev.closest('.teluce-pack-catalog__ref');
        var handle=ref.getAttribute('data-handle');
        var st=state[handle];
        var len=slidesOf(st).length||1;
        st.photoIdx=(st.photoIdx||0)-1; if(st.photoIdx<0) st.photoIdx=len-1;
        renderMedia(ref);
        return;
      }
      var next=e.target.closest('[data-ref-next]');
      if(next){
        var ref=next.closest('.teluce-pack-catalog__ref');
        var handle=ref.getAttribute('data-handle');
        var st=state[handle];
        var len=slidesOf(st).length||1;
        st.photoIdx=(st.photoIdx||0)+1; if(st.photoIdx>=len) st.photoIdx=0;
        renderMedia(ref);
        return;
      }
      var add=e.target.closest('[data-ref-add]');
      if(add){
        var ref=add.closest('.teluce-pack-catalog__ref');
        var handle=ref.getAttribute('data-handle');
        var st=state[handle];
        var msg=ref.querySelector('[data-ref-msg]');
        if(!st.selected){ if(msg) msg.textContent='Selecciona un color'; return; }
        var v=st.selected;
        var slot={variantId:String(v.id), productId:ref.getAttribute('data-id'), handle:handle, title:ref.getAttribute('data-title'), variantTitle:v.color, color:v.color, image:v.img||'', price:v.price||0};
        var ok=Store.add(slot);
        teluceTrack('slot_add', {handle: handle, color: v.color, price: v.price || 0, count: Store.count(), tier: Store.count(), ok: !!ok});
        if(msg){
          if(!ok) msg.textContent= Store.count()>=SLOT_MAX? ('Ya van '+SLOT_MAX+' — abre el carrito para confirmar') : 'Ya la tienes en tu carrito';
          clearTimeout(add._t); add._t=setTimeout(function(){ msg.textContent=''; },2400);
        }
        return;
      }
    });
    // cerrar el modal de guía de talla del catálogo (data-close-modal)
    document.addEventListener('click', function(e){
      var cb=e.target.closest('[data-close-modal]');
      if(!cb) return;
      var modal=cb.closest('.product-popup-modal');
      if(!modal) return;
      if(typeof modal.hide==='function') modal.hide();
      else modal.removeAttribute('open');
    });
    // CARRUSEL DE MINIATURAS — "movimiento de casillas" con drag con tope:
    // 5 casillas fijas (L, T0, T1, T2, R). El drag traslada el rail SOLO
    // hasta el borde (un tope suave — no deja huecos), y al soltar las cards
    // rotan de casilla (la del borde sale y la del otro lado entra, wrap
    // infinito). Cada card anima posición+escala individualmente. El layout
    // es SIEMPRE de 5 items (sin clones) → no hay salto al tocar ni re-layout.
    (function(){
      var rail=document.getElementById('teluce-pack-catalog-rail');
      if(!rail || !refs.length) return;
      var N=refs.length;
      var items=[].slice.call(rail.querySelectorAll('[data-rail-target]'));
      var trio=0;
      var itemW=0, gap=0, step=0;
      var activeIdx=-1;
      var animating=false;
      function mod(n){ return ((n%N)+N)%N; }
      function setActive(i){
        activeIdx=i;
        items.forEach(function(b){ b.classList.toggle('is-active', parseInt(b.getAttribute('data-rail-target'),10)===i); });
      }
      function measure(){
        itemW=items[0]? items[0].offsetWidth : 46;
        gap=parseFloat(getComputedStyle(rail).gap)||8;
        step=itemW+gap;
      }
      function renderStatic(){
        var order=[mod(trio-1), trio, mod(trio+1), mod(trio+2), mod(trio+3)];
        var byId={};
        items.forEach(function(b){ byId[parseInt(b.getAttribute('data-rail-target'),10)]=b; });
        items.forEach(function(b){
          var i=parseInt(b.getAttribute('data-rail-target'),10);
          var pos=order.indexOf(i);
          b.classList.toggle('is-hidden', pos<0);
          b.classList.toggle('is-peek', pos===0 || pos===4);
          b.style.transition='none';
          b.style.transform='';
        });
        order.forEach(function(i){ var b=byId[i]; if(b) rail.appendChild(b); });
        setActive(activeIdx>=0? activeIdx : 0);
      }
      function swap(dir){
        if(animating || N<3) return;
        animating=true;
        var before=[mod(trio-1), trio, mod(trio+1), mod(trio+2), mod(trio+3)];
        trio=mod(trio+dir);
        var afterOrder=[mod(trio-1), trio, mod(trio+1), mod(trio+2), mod(trio+3)];
        var byId={};
        items.forEach(function(b){ byId[parseInt(b.getAttribute('data-rail-target'),10)]=b; });
        before.forEach(function(real, oldPos){
          var b=byId[real];
          if(!b) return;
          var newPos=afterOrder.indexOf(real);
          if(newPos<0) return;
          var dPos=newPos-oldPos;
          var newIsPeek=(newPos===0||newPos===4);
          b.style.transition='transform .32s cubic-bezier(.22,1,.36,1)';
          b.style.transform='translateX('+(dPos*step)+'px) scale('+(newIsPeek? .78 : 1)+')';
          b.classList.toggle('is-peek', newIsPeek);
        });
        setTimeout(function(){
          items.forEach(function(b){ b.style.transition='none'; b.style.transform=''; });
          renderStatic();
          animating=false;
        },340);
      }
      rail.addEventListener('click', function(e){
        var b=e.target.closest('[data-rail-target]');
        if(!b || b.classList.contains('is-hidden')) return;
        var i=parseInt(b.getAttribute('data-rail-target'),10);
        var target=refs[i];
        // TAP EN UN PEEK: la card debe pasar al CENTRO del trio. El carrusel
        // rota en la dirección del peek (izq → retrocede, der → avanza) y la
        // card entra al centro; al terminar, scroll a esa prenda.
        if(b.classList.contains('is-peek')){
          // un peek está a 2 casillas del CENTRO → 2 swaps para centrarlo
          var isLeft=Array.prototype.indexOf.call(rail.children, b) < 2; // peek izquierdo
          var dir=isLeft? -1 : +1;
          var done=0;
          function step(){
            done++;
            swap(dir);
            if(done<2){ setTimeout(step, 360); }
            else { setTimeout(function(){ if(target && target.scrollIntoView) target.scrollIntoView({behavior:'smooth', block:'start'}); }, 360); }
          }
          step();
          return;
        }
        // TAP EN UNA CARD CENTRAL: solo scroll (ya está en el trio)
        if(target && target.scrollIntoView) target.scrollIntoView({behavior:'smooth', block:'start'});
      });
      // GESTO: drag con TOPE (no traslada infinito, no deja huecos) + swap al soltar
      (function(){
        var startX=0, startY=0, dragging=false, decided=false;
        var baseOffset=0;
        var MAX_DRAG=step*0.9; // tope: máximo una casilla de arrastre
        function begin(x, y){
          dragging=true; decided=false;
          startX=x; startY=y;
          baseOffset=0; // el rail está en 0 (casillas fijas)
          rail.style.transition='none';
        }
        function move(x, y){
          if(!dragging) return;
          var mx=x-startX, my=y-startY;
          if(!decided){
            if(Math.abs(mx)<8 && Math.abs(my)<8) return;
            decided=true;
            if(Math.abs(my)>Math.abs(mx)){ dragging=false; return; }
          }
          // trasladar con TOPE: no deja huecos (el rail se mueve hasta una casilla)
          var clamped=Math.max(-MAX_DRAG, Math.min(MAX_DRAG, mx));
          rail.style.transform='translateX('+clamped+'px)';
        }
        function finish(x){
          if(!dragging) return;
          dragging=false;
          var dx=(x-startX)||0;
          var TH=Math.max(20, step*0.3);
          if(dx < -TH){ swap(+1); }
          else if(dx > TH){ swap(-1); }
          else {
            rail.style.transition='transform .25s ease';
            rail.style.transform='translateX(0px)';
            setTimeout(function(){ rail.style.transition=''; },260);
          }
        }
        function cancel(){
          if(!dragging) return;
          dragging=false;
          rail.style.transition='transform .2s';
          rail.style.transform='translateX(0px)';
          setTimeout(function(){ rail.style.transition=''; },220);
        }
        rail.addEventListener('touchstart', function(e){ var t=e.touches[0]; if(t) begin(t.clientX, t.clientY); }, {passive:true});
        rail.addEventListener('touchmove', function(e){
          var t=e.touches[0]; if(!t) return;
          move(t.clientX, t.clientY);
          if(decided && dragging && Math.abs(t.clientX-startX)>Math.abs(t.clientY-startY)){
            try{ e.preventDefault(); }catch(err){}
          }
        }, {passive:false});
        rail.addEventListener('touchend', function(e){ var c=e.changedTouches[0]; if(c) finish(c.clientX); }, {passive:true});
        rail.addEventListener('touchcancel', cancel, {passive:true});
        rail.addEventListener('pointerdown', function(e){ begin(e.clientX, e.clientY); });
        rail.addEventListener('pointermove', function(e){ move(e.clientX, e.clientY); });
        rail.addEventListener('pointerup', function(e){ finish(e.clientX); });
        rail.addEventListener('pointercancel', cancel);
      })();
      if('IntersectionObserver' in window){
        var io=new IntersectionObserver(function(entries){
          entries.forEach(function(en){
            if(en.isIntersecting){
              var idx=refs.indexOf(en.target);
              if(idx>=0){ setActive(idx); activeRefIdx=idx; }
            }
          });
        },{ threshold:.5 });
        refs.forEach(function(r){ io.observe(r); });
      }
      measure();
      renderStatic();
      // DEEP-LINK DE CAMPAÑA: /collections/all?p=<handle> → centra el carrusel
      // en esa prenda, hace scroll a su card y la resalta brevemente. Así el
      // link de campaña desemboca DIRECTO en esa prenda dentro del catálogo.
      var _deepLinked = false;
      (function(){
        var m = location.search.match(/[?&]p=([^&]+)/);
        if (!m) return;
        var handle = decodeURIComponent(m[1]);
        var idx = -1;
        refs.forEach(function(ref, i){ if (ref.getAttribute('data-handle') === handle) idx = i; });
        if (idx < 0) return;
        _deepLinked = true;
        trio = mod(idx - 1); // centro del trio = idx
        setActive(idx);
        renderStatic();
        var target = refs[idx];
        setTimeout(function(){
          if (target && target.scrollIntoView) target.scrollIntoView({behavior:'smooth', block:'start'});
        }, 320);
      })();
      // INVITACIÓN DE SWIPE: micro-nudge al cargar (una vez por página) —
      // un pequeño desplazamiento que muestra que el carrusel se desliza.
      try{
        if(_deepLinked) return;
        if(sessionStorage.getItem('teluce_swipe_hint')==='1') return;
        sessionStorage.setItem('teluce_swipe_hint','1');
        setTimeout(function(){
          rail.style.transition='transform .4s cubic-bezier(.22,1,.36,1)';
          rail.style.transform='translateX('+(-step*0.35)+'px)';
          setTimeout(function(){
            rail.style.transform='translateX(0px)';
            setTimeout(function(){ rail.style.transition=''; },400);
          },420);
        },1200);
      }catch(e){}
    })();
    refs.forEach(loadRef);
    renderSlots();
    // renderHead se saco de adentro de renderSlots: esa funcion tiene guarda
    // `if(!slotsEl) return` y, al quitar los slots del head, el head quedaba
    // sin actualizar. Ahora se llama desde afuera, donde ya no depende del DOM
    // de los slots.
    renderHead(Store.count());
    // barra fixed top:0 full-width — compensar su altura + COLAPSABLE manual
    (function(){
      var top=root.querySelector('.teluce-pack-catalog__top');
      if(!top) return;
      var isMobile=window.matchMedia('(max-width: 749px)').matches;
      // El top ya NO es fijo (es un cover que scrollea), asi que compensar su
      // altura agregaria un hueco fantasma arriba del contenido.
      var set=function(){};
      set();
      window.addEventListener('resize', set);
      // COLAPSABLE a decisión del usuario (chevron). Persiste en localStorage.
      var KEY='teluce_catalog_collapsed';
      var btn=top.querySelector('[data-catalog-collapse]');
      function apply(collapsed){
        top.classList.toggle('is-collapsed', collapsed);
        if(btn) btn.setAttribute('aria-expanded', collapsed?'false':'true');
        if(btn) btn.setAttribute('aria-label', collapsed?'Expandir el resumen':'Colapsar el resumen');
        set();
        setTimeout(set, 340); // recalcular padding tras la transición
      }
      // El colapsable se elimino: el head es todo storytelling y no hay nada
      // que plegar. apply(false) siempre, porque con el estado guardado el
      // head arrancaria colapsado igual aunque el boton no exista.
      var saved=false;
      apply(false);
      if(btn){
        btn.addEventListener('click', function(){
          var next=!top.classList.contains('is-collapsed');
          try{ localStorage.setItem(KEY, next?'1':'0'); }catch(e){}
          apply(next);
        });
      }
    })();
    if(window.subscribe && window.PUB_SUB_EVENTS) subscribe(PUB_SUB_EVENTS.mixMatchUpdate, function(){ renderSlots(); renderHead(Store.count()); });
  }
  // DOTS DE COLOR BAJO LA GALERÍA (mobile): el usuario ve la prenda y navega
  // colores sin scroll. Tocar un dot = seleccionar la variante (mismo flujo
  // nativo). Se re-inicializa tras el re-render de Craft (observer).
  // Galería del PDP: el video del color es un FONDO VIVO (autoplay + loop,
  // sin controles ni poster que tocar) — mismo lenguaje que el video del
  // catálogo. Dawn lo deja en un deferred-media que recién carga al click:
  // acá se dispara solo. loadContent(false) evita el focus/scroll.
  function initGalleryVideo(){
    var list=document.querySelectorAll('.media-type-video deferred-media');
    if(!list.length) return;
    Array.prototype.forEach.call(list, function(dm){
      if(dm.getAttribute('data-teluce-video')==='1') return;
      dm.setAttribute('data-teluce-video','1');
      try{ if(typeof dm.loadContent==='function') dm.loadContent(false); }catch(e){}
      var v=dm.querySelector('video');
      if(v){
        v.muted=true; v.controls=false; v.loop=true;
        v.setAttribute('playsinline','');
        try{ v.play(); }catch(e){}
      }
    });
  }

  // Cómo oculta el tema los slides NO activos: visibility:hidden (NO display:none
  // — esa es la regla de desktop). Un elemento visibility:hidden CONSERVA su caja,
  // así que IntersectionObserver lo sigue viendo como visible y no sirve acá.
  // El tema togglea una clase al navegar (is-active); se observa esa clase y la
  // decisión sale del computed style, no de la geometría.
  // Sin esto: al salir del slide el video quedaba corriendo fuera de pantalla
  // (datos/batería) y al volver quedaba congelado, porque initGalleryVideo tiene
  // guard y no re-carga.
  var galleryVideoObserver = null;

  function syncGalleryVideo(slide){
    var v=slide.querySelector('video');
    if(!v) return;
    var cs=getComputedStyle(slide);
    var visible = cs.visibility!=='hidden' && cs.display!=='none';
    if(visible){
      if(v.paused){ try{ v.play(); }catch(err){} }
    }else{
      if(!v.paused){ try{ v.pause(); }catch(err){} }
    }
  }

  function initGalleryVideoObserver(){
    if(!('MutationObserver' in window)) return;
    var slides=document.querySelectorAll('.product__media-item');
    if(!slides.length) return;
    if(galleryVideoObserver) galleryVideoObserver.disconnect();
    galleryVideoObserver=new MutationObserver(function(muts){
      Array.prototype.forEach.call(muts,function(m){
        var s=m.target;
        if(s && s.querySelector && s.querySelector('video, deferred-media')) syncGalleryVideo(s);
      });
    });
    Array.prototype.forEach.call(slides,function(s){
      if(s.querySelector('video, deferred-media')){
        galleryVideoObserver.observe(s,{attributes:true,attributeFilter:['class']});
        syncGalleryVideo(s);
      }
    });
  }

  // DRAWER DE CONFIRMACIÓN DE COMPRA (PDP).
  // Existe porque la clienta decidía comprar sin haber elegido color: los dots
  // de la galería son para curiosear, no para decidir. Acá confirma el color
  // y, si el producto tiene packs, se ofrece llevarse más colores.
  //
  // Reglas: default 1 slot con el color activo; los switches (debajo de los
  // slots) gobiernan cuántos slots hay; volver a 1 NO borra lo elegido en los
  // otros (si vuelve a subir, lo encuentra).
  var _buyData = null;

  function buyTier(){
    if(!_buyData) return null;
    var i = _buyData._tierIdx || 0;
    return _buyData.tiers[i] || _buyData.tiers[0];
  }

  function buyRender(root){
    if(!_buyData) return;
    var t = buyTier();
    var n = t ? t.qty : 1;
    var chosen = _buyData._chosen;
    var variants = _buyData.variants;

    // completar slots si el tier pide más (sin truncar: lo elegido se conserva)
    while(chosen.length < n){
      var pick = '';
      for(var i=0;i<variants.length;i++){
        if(variants[i].avail && chosen.indexOf(variants[i].id)===-1){ pick = variants[i].id; break; }
      }
      chosen.push(pick || (variants[0] && variants[0].id));
    }

    var slotsEl = root.querySelector('[data-buy-slots]');
    var tiersEl = root.querySelector('[data-buy-tiers]');
    var totalEl = root.querySelector('[data-buy-total]');
    var mostrar = chosen.slice(0, n);

    if(slotsEl){
      // Cuantos slots habia ANTES de re-renderizar: los que ya existian no
      // deben animar de nuevo. Antes la animacion estaba en la clase base y
      // cada cambio de color re-montaba las tres filas -> parpadeo.
      var previos = slotsEl.children.length;
      slotsEl.innerHTML = mostrar.map(function(id, si){
        var esNuevo = si >= previos;
        var cur = null, vv;
        for(var i=0;i<variants.length;i++){ if(variants[i].id===id) cur = variants[i]; }
        vv = cur || variants[0] || {};
        var swatches = variants.map(function(v){
          var act = v.id===id ? ' is-active' : '';
          var dis = v.avail ? '' : ' disabled';
          var bg = v.img ? ' style="background-image:url(' + v.img + ')"' : '';
          return '<button type="button" class="teluce-buy-drawer__swatch'+act+'" data-buy-slot="'+si+'" data-buy-color="'+v.id+'"'+dis+bg+' aria-label="'+String(v.color).replace(/"/g,'&quot;')+'"></button>';
        }).join('');
        // Con oferta activa: el precio con descuento manda (terracota) y abajo,
        // tachado y en gris, el original. El precio con descuento es el que
        // importa; el tachado solo justifica de donde viene.
        // El precio original sale de base; si no esta (JSON viejo en cache del
        // navegador), cae al total del tier 1, que siempre es el precio full.
        // Sin este respaldo el span salia vacio y el tachado no se veia.
        var precioFull = _buyData.base || (_buyData.tiers && _buyData.tiers[0] && _buyData.tiers[0].total) || '';
        var precio = (t && t.qty > 1 && t.ahorro && precioFull)
          ? '<span class="teluce-buy-drawer__slot-price">'+t.unit
            + '<span class="teluce-buy-drawer__slot-was">'+precioFull+'</span></span>'
          : '<span class="teluce-buy-drawer__slot-price">'+t.unit+'</span>';
        return '<div class="teluce-buy-drawer__slot'+(esNuevo?' is-entering':'')+'">'
          + '<div class="teluce-buy-drawer__slot-colors">'+swatches+'</div>'
          + '<span class="teluce-buy-drawer__slot-name">'+String(vv.color||'')+'</span>'
          + precio
          + '</div>';
      }).join('');
    }

    if(tiersEl){
      tiersEl.innerHTML = (_buyData.tiers||[]).map(function(tt, i){
        var act = i===(_buyData._tierIdx||0) ? ' is-active' : '';
        // etiqueta corta: el chip mide un tercio del ancho, no entra mas texto
        var label = tt.qty===1 ? '1 color' : tt.qty+' colores';
        var save = tt.ahorro ? '<span class="teluce-buy-drawer__tier-save">ahorras '+tt.ahorro+'</span>' : '';
        // Radio decorativo en la esquina: la seleccion era implicita (un borde
        // mas grueso) y obligaba a comparar. aria-hidden porque el estado real
        // lo declara el aria-pressed del boton.
        var activo = (i===(_buyData._tierIdx||0));
        return '<button type="button" class="teluce-buy-drawer__tier'+act+'" data-buy-tier="'+i+'"'
          + ' role="radio" aria-checked="'+(activo?'true':'false')+'">'
          + '<span class="teluce-buy-drawer__radio" aria-hidden="true"></span>'
          + '<span>'+label+'</span>'
          + '<span class="teluce-buy-drawer__tier-price">'+tt.total+'</span>'
          + save
          + '</button>';
      }).join('');
    }

    if(totalEl) totalEl.textContent = t ? t.total : '';

    // El CTA refleja cuantas prendas lleva. Cierra la pregunta "cuantas ya
    // tengo?" sin abrir el drawer, y sobrevive a cerrarlo para mirar fotos.
    Array.prototype.forEach.call(document.querySelectorAll('[data-pdp-buy],[data-pdp-buy-desk]'), function(b){
      var badge = b.querySelector('.teluce-pdp-count');
      if(n > 1){
        if(!badge){
          badge = document.createElement('span');
          badge.className = 'teluce-pdp-count';
          badge.setAttribute('aria-hidden','true');
          b.appendChild(badge);
        }
        badge.textContent = n;
        b.setAttribute('aria-label', 'Listo, quiero comprar. ' + n + ' prendas elegidas.');
      }else if(badge){
        badge.remove();
        b.removeAttribute('aria-label');
      }
    });

    // El head dice que se esta eligiendo: con 1 color es "tu color", con 2 o 3
    // son "tus colores". El titulo sigue al tier activo.
    var titleEl = root.querySelector('[data-buy-title]');
    if(titleEl) titleEl.textContent = (n > 1) ? 'Selecciona tus colores' : 'Selecciona tu color';
  }

  function buyOpen(){
    var root = document.getElementById('TeluceBuyDrawer');
    var dataEl = document.querySelector('[data-buy-data]');
    if(!root || !dataEl || !_buyData) return false;
    // NO se resetea: si la clienta cierra el drawer para volver a mirar los
    // colores en la galeria y lo reabre, encuentra lo que ya habia elegido
    // (tier + colores). El estado inicial lo setea initBuyDrawer una sola vez.
    buyRender(root);
    // El confirmar se deshabilita mientras trabaja. Si la clienta cierra el
    // form de Releasit y vuelve, el drawer tiene que estar usable otra vez —
    // sin esto el boton quedaba muerto para siempre (misma trampa que el
    // "Abriendo..." de la buybar).
    var cb = root.querySelector('[data-buy-confirm]');
    if(cb) cb.disabled = false;
    if(typeof root.show === 'function') root.show(); else root.setAttribute('open','');
    return true;
  }

  function initBuyDrawer(){
    var root = document.getElementById('TeluceBuyDrawer');
    var dataEl = document.querySelector('[data-buy-data]');
    if(!root || !dataEl) return;
    try { _buyData = JSON.parse(dataEl.textContent); } catch(e) { return; }
    _buyData._tierIdx = 0;
    _buyData._chosen = [_buyData.current];

    var data = _buyData;

    // abrir desde el CTA del PDP: la buybar emite el evento (desacoplado, así
    // el snippet del CTA no necesita saber nada del drawer)
    document.addEventListener('teluce:buy-open', function(){ buyOpen(); });
    // El CTA de desktop no pasa por la buybar (mobile-only): abre el mismo drawer.
    document.addEventListener('click', function(e){
      var b = e.target && e.target.closest ? e.target.closest('[data-pdp-buy-desk]') : null;
      if(b) buyOpen();
    });

    root.addEventListener('click', function(ev){
      var el = ev.target.closest ? ev.target.closest('[data-buy-close],[data-buy-tier],[data-buy-color],[data-buy-confirm]') : null;
      if(!el) {
        if(ev.target === root && typeof root.hide === 'function') root.hide();
        return;
      }
      // cerrar
      if(el.hasAttribute('data-buy-close')){
        if(typeof root.hide === 'function') root.hide(); else root.removeAttribute('open');
        return;
      }
      // cambiar de tier
      if(el.hasAttribute('data-buy-tier')){
        data._tierIdx = Number(el.getAttribute('data-buy-tier')) || 0;
        buyRender(root);
        return;
      }
      // elegir color de un slot
      if(el.hasAttribute('data-buy-color')){
        var si = Number(el.getAttribute('data-buy-slot')) || 0;
        var vid = Number(el.getAttribute('data-buy-color'));
        data._chosen[si] = vid;
        buyRender(root);
        return;
      }
      // confirmar
      if(el.hasAttribute('data-buy-confirm')){
        buyConfirm(el, root);
        return;
      }
    });
  }

  async function buyConfirm(btn, root){
    if(!_buyData || btn.disabled) return;
    var t = buyTier();
    var n = t ? t.qty : 1;
    var items = _buyData._chosen.slice(0, n).map(function(id){ return { id: id, quantity: 1 }; });

    // Estado de carga desde el MOMENTO CERO. Entre el click y el handoff a
    // Releasit hay dos fetches (clear + add); antes de esto el boton quedaba
    // deshabilitado pero con aspecto inactivo: sin shimmer, sin spinner y sin
    // ninguna senal de que hubiera pasado algo.
    var labelEl = btn.querySelector('.teluce-buy-drawer__confirm-label');
    var released = false;
    function release(msg){
      if(released) return; released = true;
      btn.disabled = false;
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
      if(labelEl) labelEl.textContent = msg || 'Confirmar pedido';
    }
    btn.disabled = true;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    if(labelEl) labelEl.textContent = 'Preparando tu pedido…';

    try {
      // Se LIMPIA el carrito antes de agregar: a Releasit solo debe llegar lo
      // que la clienta confirmó en este drawer. Sin esto, restos de un carrito
      // anterior (otra sesión, una prueba, un pack a medio armar) se cuelan en
      // la orden y la clienta ve items que no eligió acá.
      // Dos fuentes, porque una sola no alcanza:
      //  - cartCount: lo que ya venia en el carrito cuando se cargo la pagina
      //    (valor del servidor, congelado — un item agregado despues no lo mueve)
      //  - _cartDirty: lo que agregamos nosotros en esta sesion (carrito vacio
      //    al cargar, pero con items despues del primer confirmar)
      // Con solo cartCount el carrito no se limpiaba en los confirmar siguientes
      // y Releasit mostraba valores apilados.
      // Instrumentado: el confirm es una cadena larga (2 fetches propios + el
      // handoff a Releasit, que renderiza su form con React desde cero, porque
      // no existe en el HTML). Los marks dicen DONDE se van los segundos; sin
      // esto se optimiza a ciegas. El total queda como tag de Clarity para
      // poder filtrar las grabaciones donde el confirm fue lento.
      var t0 = (window.performance && performance.now) ? performance.now() : Date.now();
      function mark(step){
        var t = (window.performance && performance.now) ? performance.now() : Date.now();
        var ms = Math.round(t - t0);
        teluceTrack('confirm_step', { step: step, ms: ms });
        return ms;
      }
      mark('start');
      if(_buyData.cartCount > 0 || _buyData._cartDirty){
        try {
          await fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } });
        } catch(e) {}
      }
      mark('cart_cleared');
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      });
      mark('cart_added');
      // handoff: el buy-now oculto de Releasit (mismo proxy que el drawer del pack)
      var tries = 0;
      function intento(){
        tries++;
        var rb = document.getElementById('rsi_buy_now_button');
        if(rb){
          clearInterval(iv);
          mark('button_found');
          rb.click();
          var total = mark('clicked');
          try{ if(window.clarity) window.clarity('set', 'confirm_ms', String(total)); }catch(e){}
          // El estado de carga dura hasta que el FORM este en pantalla, no hasta
          // que aparezca el boton de Releasit: entre uno y otro hay varios
          // segundos, y ahi el shimmer y el spinner desaparecian y el boton
          // volvia a verse inactivo.
          teluceWaitForForm(function(opened){
            mark(opened ? 'form_open' : 'form_timeout');
            // Si el form nunca llego, que la clienta lo sepa: antes se soltaba
            // el boton en silencio y el click parecia no haber hecho nada.
            release(opened ? '' : 'No pudimos abrir el pedido. Intenta de nuevo.');
          });
          return;
        }
        var cb2 = document.getElementById('CartDrawer-Checkout');
        if(cb2 && !cb2.disabled){
          clearInterval(iv);
          mark('checkout_btn');
          cb2.click();
          release();
          return;
        }
        // 100 x 60ms = ~6s. Antes eran 33 (~2s), y con un bundle de 387 KB en
        // movil el boton de Releasit no llegaba a tiempo: saltaba el fallback y
        // la clienta terminaba en el checkout de Shopify, no en el form COD.
        if(tries >= 100){
          clearInterval(iv);
          try{ if(window.clarity) window.clarity('set', 'confirm_ms', String(mark('fallback_nav'))); }catch(e){}
          window.location.href = '/checkout';
        }
      }
      // Primer intento INMEDIATO, y despues cada 60ms.
      intento();
      var iv = setInterval(intento, 60);
      // el carrito ya tiene lo nuestro: el proximo confirmar tiene que limpiar
      _buyData._cartDirty = true;
      // 8s y no 3s: si el boton se re-habilita ANTES de que el form aparezca,
      // la clienta puede volver a apretar con el pedido ya en curso — el
      // carrito se limpia y se re-agrega, y Releasit puede crear un segundo
      // draft order.
      setTimeout(release, 8000);
    } catch(e) {
      // release() y no solo btn.disabled=false: con is-loading puesto, un error
      // dejaba el spinner girando para siempre.
      release();
    }
  }

  function initGalleryColors(){
    var box=document.getElementById('teluce-gallery-colors');
    if(!box || !host) return;
    var handle=(location.pathname.split('/products/')[1]||'').split('/')[0].split('?')[0];
    if(!handle) return;
    if(!productVariantsCache[handle]){ maybeLoadColors(handle); return; }
    var variants=productVariantsCache[handle];
    if(!variants || !variants.length){ box.hidden=true; return; }
    box.hidden=false;
    box.innerHTML=variants.map(function(v){
        var hex=colorHex(v.color);
        var style=v.img? 'background-image:url('+v.img+');background-size:cover;background-position:center' : (hex? 'background:'+hex : '');
        var active=isSelectedVariant(v.id);
        return '<button type="button" class="teluce-gallery-colors__dot'+(active?' is-active':'')+'" data-gallery-color="'+v.id+'" style="'+style+'" title="'+String(v.color).replace(/"/g,'&quot;')+'"></button>';
      }).join('');
  }
  function isSelectedVariant(vid){
    try{
      var vs=document.querySelector('variant-selects');
      var sel=vs&&vs.querySelector('[data-selected-variant]');
      if(sel){ var v=JSON.parse(sel.textContent); return String(v.id)===String(vid); }
    }catch(e){}
    return false;
  }
  // Precarga por INTENCION del cambio de color.
  // Al cambiar de color, Dawn re-renderiza toda la seccion "main-product" por
  // fetch (~55 KB) y eso se siente en cada toque. La seccion se puede pedir
  // ANTES del click: cuando el dedo toca (o el mouse pasa por) el dot, ya
  // sabemos que color viene. El navegador lo guarda en su cache HTTP y el
  // fetch del click llega instantaneo.
  // Queda pendiente lo que esto NO resuelve: las fotos del color nuevo se
  // descargan igual (no estan en cache la primera vez).
  var _colorPrefetch = {};
  function prefetchColor(vid){
    if(!vid || _colorPrefetch[vid]) return;
    _colorPrefetch[vid] = 1;
    try{
      var l = document.createElement('link');
      l.rel = 'prefetch';
      l.href = location.pathname + '?variant=' + vid + '&section_id=main-product';
      document.head.appendChild(l);
    }catch(e){}
  }
  function prefetchDesde(e){
    var d = e.target && e.target.closest ? e.target.closest('[data-gallery-color]') : null;
    if(d) prefetchColor(d.getAttribute('data-gallery-color'));
  }
  document.addEventListener('mouseover', prefetchDesde, {passive:true});
  document.addEventListener('touchstart', prefetchDesde, {passive:true});

  document.addEventListener('click', function(e){
    var d=e.target.closest('[data-gallery-color]');
    if(!d) return;
    var vid=d.getAttribute('data-gallery-color');
    // OJO: NO usar 'variant-selects input[data-product-url*="variant=VID"]' —
    // el radio de TALLA (Talla única) tiene el data-product-url de la
    // variante DEFAULT (siempre checked) y matchea PRIMERO en el DOM → el
    // dot del color default parecía "ya seleccionado" y nunca switcheaba.
    // Scope estricto a los swatches de color (.swatch-input__input).
    var input=document.querySelector('variant-selects .swatch-input__input[data-product-url*="variant='+vid+'"]');
    if(!input) return;
    if(input.checked){
      // ya en ese color: devolver la galería al primer slide (feedback visible
      // para el toque en el dot del color activo)
      var gal=document.querySelector('media-gallery');
      var first=gal && gal.querySelector('li[data-media-id]');
      if(gal && first && typeof gal.setActiveMedia==='function') gal.setActiveMedia(first.dataset.mediaId, false);
      return;
    }
    // NO input.click(): con el fieldset de Color oculto (display:none en
    // mobile), Safari/iOS no cambia el checkedness ni dispara change sobre
    // un radio oculto. Seteo checked + dispatch de change = funciona siempre.
    input.checked=true;
    input.dispatchEvent(new Event('change',{bubbles:true}));
  });
  // OFERTA DE LA CAMPANA DE BASICAS: lleva 4 paga 3 / lleva 6 paga 4.
  // El theme NO cobra: solo muestra. Quien cobra es el descuento AUTOMATICO de
  // Shopify ("Compra X y llevate Y"), que hay que configurar en el Admin asi:
  //     Compra 4, llevate 1   |   Compra 6, llevate 2
  // Si estas dos reglas cambian en el Admin, hay que cambiar freeCount() aca
  // para que el mensaje siga diciendo la verdad. Es el unico punto de sync.
  function freeFor(n){
    if(n>=6) return 2;
    if(n>=4) return 1;
    return 0;
  }
  function freeCount(){ return freeFor(Store.count()); }
  // Total = suma de las prendas menos las gratis. La gratis se toma del PRECIO
  // MAS BAJO, que es como lo resuelve el descuento nativo de Shopify cuando los
  // precios varian (hoy todas las basicas valen igual, pero no dependemos de eso).
  // La matematica del pack se expone: el render del drawer vive en otro IIFE
  // y la necesita. Mismo patron que window.TeluceMixMatchStore.
  // COPY del aviso, en UN lugar: el toast y la franja sticky leen de aca. Hoy
  // ya nos paso que el mismo texto vivia en dos archivos con numeros distintos.
  var REGALO = '🎁';
  var FREE_COPY = {
    3: 'Agrega <b class="teluce-pack-toast__hl">GRATIS</b> una 4ta que solo pagas estas 3',
    5: 'Elige <b class="teluce-pack-toast__hl">GRATIS</b> una 6ta que solo vas a pagar 4'
  };
  window.TelucePackMath = { bundlePrice: bundlePrice, freeCount: freeCount, freeFor: freeFor, freeCopy: FREE_COPY, gift: REGALO };
  function bundlePrice(){
    var s=Store.slots.filter(Boolean);
    if(s.length<2) return 0;
    var sum=s.reduce(function(a,b){return a+b.price;},0);
    var free=freeCount();
    if(!free) return sum;
    var min=Math.min.apply(null, s.map(function(x){return x.price;}));
    return sum - min*free;
  }
  // Compatibility: devuelve el % real que representa el descuento por unidades,
  // SOLO para el tag de Clarity. La UI ya no muestra porcentajes.
  function pct(){
    var c=Store.count();
    if(c<4) return 0;
    var free=freeCount();
    return Math.round(free/c*100);
  }
  // UI — builder pulido v2: slots INFORMATIVOS (no botones), CTA
  // "Agregar al pack" de vuelta, pills de packs (premio terracota),
  // resumen solo-dinero, CTA condicional, vaciar secundario. TUTEO.
  function render(){
    var c=Store.count();
    var pctVal=pct();
    var sum=Store.slots.filter(Boolean).reduce(function(a,b){return a+b.price;},0);
    var bPrice=bundlePrice();
    var save=sum-bPrice;
    // beneficios tangibles por slot (referencia: precio del producto actual;
    // fallback al primer slot lleno). Si no hay precio, solo el %.
    var refPrice=0;
    var curSlot=getCurrentSlot();
    if(curSlot && curSlot.price) refPrice=curSlot.price;
    else if(c>0){ var filledSlots=Store.slots.filter(Boolean); refPrice=filledSlots[0].price||0; }
    // Los factores tienen que seguir al descuento real del admin (10% y 15%).
    // Estaban en 0.15 y 0.25: mostraban un ahorro que ya no coincidia con lo
    // que cobra. Se buscan por factor decimal, no por el simbolo %, por eso
    // habian pasado el primer barrido.
    // beneficio del slot 2/3: % diferenciado del monto fijo
    // slot "próximo" = invitación destacada; los futuros = "estás por lograr"
  var activatedTier=(c===2||c===3)&&c>lastCount;
    if(activatedTier) teluceTrack('tier_reached', {tier: c});
    var subheads=[
      'Empieza a lucir, elige tu 1ra prenda',
    ];
    // CTA contextual: si la PRENDA del PDP (mismo handle, cualquier color)
    // ya está en el pack → "Agregar otra". El cambio de color de la MISMA
    // prenda NO debe cambiar los labels (misma prenda = misma etiqueta).
    var curHandle=curSlot? curSlot.handle : null;
    var currentInPack = curHandle ? Store.slots.some(function(s){ return s && s.handle===curHandle; }) : false;
    var addLabel = currentInPack? 'Agregar otra' : 'Agregar a la compra';
    // SIN lógica de "Actualizar compra": el flujo es agregar/quitar/cambiar
    // color y volver a "Listo, quiero comprar" — el sync siempre re-monta.
    var confirmLabel;
    // Confirm con 1 blusa: "Comprar esta blusa" si es la del PDP; si la
    // única del pack es OTRA prenda (otro handle) → "Comprar la que ya elegí"
    confirmLabel = c===1 ? 'Comprar esta prenda' : c===2? 'Comprar 2 básicas' : 'Comprar 3 básicas';
    if(c===1){
      var packSlot0=Store.slots.filter(Boolean)[0];
      if(curHandle && packSlot0 && packSlot0.handle!==curHandle) confirmLabel='Comprar la que ya elegí';
    }
    // Slots (compartidos PDP + drawer): la INVITACIÓN a elegir es narrativa
    // en ambos — el slot próximo se destaca (is-next) y los futuros marcan
    // el tramo (is-future). En el drawer también se puede cambiar color y
    // quitar prendas (los clics se delegan a document, ver events abajo).
    function slotHtml(s,i){
      if(s){
        var dots='';
        var variants=productVariantsCache[s.handle];
        if(variants&&variants.length){
          dots='<div class="teluce-pack-slot__colors">'+variants.map(function(v){
            var isActive=String(v.id)===String(s.variantId);
            var hex=colorHex(v.color);
            // el dot muestra la FOTO del color ([COLOR]_1) si existe; si no, hex
            var style=v.img? 'background-image:url('+v.img+');background-size:cover;background-position:center' : (hex? 'background:'+hex : '');
            return '<button type="button" class="teluce-pack-slot__dot'+(isActive?' is-active':'')+'" data-slot-color="'+i+'" data-variant="'+v.id+'" title="'+String(v.color).replace(/"/g,'&quot;')+'" style="'+style+'"></button>';
          }).join('')+'</div>';
        }
        // Precio del slot: si el pack tiene descuento (pctVal), el precio real
        // va tachado en gris (empujado al fondo) y DEBAJO el precio con el %
        // aplicado (terracota = el premio). Mismo % que el resumen (pct()).
        var priceHtml='$ '+Math.round(s.price).toLocaleString('es-CO');
        if(pctVal>0){
          var newPrice='$ '+Math.round(s.price*(1-pctVal/100)).toLocaleString('es-CO');
          priceHtml='<span class="teluce-pack-slot__price-old">'+priceHtml+'</span>'+
                    '<span class="teluce-pack-slot__price-new">'+newPrice+'</span>';
        }
        return '<div class="teluce-pack-slot-col"><div class="teluce-pack-slot is-filled"><img src="'+s.image+'" alt=""><div class="teluce-pack-slot__meta"><strong>'+s.title+'</strong><span>'+normalizeColor(s.color).display+'</span>'+dots+'</div><button data-remove="'+i+'" aria-label="Quitar del pack">×</button></div><div class="teluce-pack-slot__price'+(pctVal>0?' is-discounted':'')+'">'+priceHtml+'</div></div>';
      }
      // Los slots VACIOS no se renderizan: el componente slot (estilo, imagen
      // del color elegido, boton de cerrar) se mantiene igual, pero la seccion
      // arranca OCULTA y aparece sumando un slot por prenda agregada.
      return '';
    }
    var filledNow=Store.slots.filter(Boolean);
    var slotsHtml= filledNow.length
      ? '<div class="teluce-pack-slots">'+Store.slots.map(function(s,i){ return s?slotHtml(s,i):''; }).join('')+'</div>'
      : '';
    var confirmBtn='';
    if(c>=1){
      confirmBtn='<button class="button button--primary teluce-pack-confirm" data-pack-confirm>'+confirmLabel+'</button>';
    }
    // BARRA DE ACCION (mobile): muta entre invitacion y CTA segun cuantas
    // prendas hay. NO inventa logica de compra: dispara el [data-pack-confirm]
    // que ya existe, que es quien sabe armar el pack. Si ese boton no esta
    // (c<1), la barra queda en su estado de invitacion y no es clickeable.
    var packBar=document.querySelector('[data-pack-bar]');
    if(packBar){
      var barCta=packBar.querySelector('[data-pack-bar-cta]');
      var barN=packBar.querySelector('[data-pack-bar-count]');
      packBar.classList.toggle('is-active', c>=1);
      // Confeti SOLO al subir hacia 4/5/6, no en cada render: guardamos el
      // conteo previo en el propio elemento para no agregar estado global.
      var prev=parseInt(packBar.getAttribute('data-count')||'0',10);
      if(c>prev && c>=4 && c<=6) teluceConfetti();
      packBar.setAttribute('data-count', String(c));

      // FRANJA STICKY: misma condicion que el chip fantasma. Si agregar una mas
      // gana algo, se avisa arriba — donde se ve aunque el cliente este abajo.
      var franja=document.querySelector('[data-pack-toast]');
      // Se MUEVE al body: dentro de la seccion, cualquier ancestro con
      // transform/filter/contain/will-change convierte position:fixed en
      // absolute y el aviso se iria scrolleando. Colgado del body, fixed es
      // garantizado — hoy y si manana alguien agrega un transform arriba.
      if(franja && franja.parentElement!==document.body) document.body.appendChild(franja);
      if(franja){
        var libresAhora=(window.TelucePackMath&&window.TelucePackMath.freeFor)? window.TelucePackMath.freeFor(c) : 0;
        var libresProx=(window.TelucePackMath&&window.TelucePackMath.freeFor)? window.TelucePackMath.freeFor(c+1) : 0;
        var hayPremio=libresProx>libresAhora;
        var fmsg=franja.querySelector('[data-pack-toast-msg]');
        var fm=(window.TelucePackMath&&window.TelucePackMath.freeCopy)||{};
        // Emojis de regalo: uno por cada prenda gratis que desbloquea la
        // proxima. Sale de freeFor(c+1), no de un numero escrito: con 3
        // desbloquea 1, con 5 desbloquea 2. Si cambia la campana, los emojis
        // la siguen solos.
        var nPremios=(window.TelucePackMath&&window.TelucePackMath.freeFor)? window.TelucePackMath.freeFor(c+1) : 0;
        var marca=''; for(var g=0;g<nPremios;g++) marca+=REGALO+' ';
        if(fmsg && fm[c]) fmsg.innerHTML=marca+fm[c];
        franja.hidden = !hayPremio;
      }
      var chips=packBar.querySelector('[data-pack-bar-chips]');
      if(chips){
        var llenos=Store.slots.filter(Boolean);
        var cLlenos=llenos.length;
        chips.hidden = cLlenos===0;
        // MISMAS dos reglas que el drawer del catalogo (no re-deducidas):
        // - GRATIS = pos >= (llenados - freeCount()). Si aca se marca una prenda
        //   que el drawer cobra, prometemos algo falso.
        // - el indice de remove es ABSOLUTO (Store.slots.indexOf), no la posicion
        //   entre los visibles: con huecos, un indice relativo borra la vecina.
        var libres = window.TelucePackMath ? window.TelucePackMath.freeCount() : 0;
        var ghostHtml='';
        if(window.TelucePackMath && window.TelucePackMath.freeFor){
          if(window.TelucePackMath.freeFor(cLlenos+1) > window.TelucePackMath.freeFor(cLlenos)){
            ghostHtml='<span class="teluce-pack-bar__chip teluce-pack-bar__chip--ghost" aria-hidden="true">'+
              '<span class="teluce-pack-bar__chip-gift">🎁</span></span>';
          }
        }
        chips.innerHTML = llenos.map(function(s,pos){
          var idx = Store.slots.indexOf(s);
          var esGratis = pos >= (cLlenos - libres);
          var hex=colorHex(s.color);
          var st=s.image? 'background-image:url('+s.image+');background-size:cover;background-position:center' : (hex? 'background:'+hex : '');
          var nom=String(s.title||'prenda').replace(/"/g,'&quot;');
          return '<button type="button" class="teluce-pack-bar__chip'+(esGratis?' is-free':'')+'" data-chip-remove="'+idx+'" style="'+st+'" aria-label="Quitar '+nom+(esGratis?' — GRATIS':'')+'">'+
            (esGratis?'<span class="teluce-pack-bar__chip-gift" aria-hidden="true">🎁</span>':'')+
            '<span class="teluce-pack-bar__chip-x" aria-hidden="true">×</span></button>';
        }).join('') + ghostHtml;
      }
  function teluceConfetti(){
    if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var box=document.createElement('div');
    box.className='teluce-confetti';
    var colores=['#f0d68a','#dcb85a','#c39a3c','#b4552d','#9a3d24','#ffffff'];
    for(var i=0;i<28;i++){
      var el=document.createElement('i');
      el.className='teluce-confetti__p';
      el.style.left=(Math.random()*100)+'%';
      el.style.background=colores[i%colores.length];
      el.style.setProperty('--dx',(Math.random()*140-70)+'px');
      el.style.setProperty('--rot',(Math.random()*720-360)+'deg');
      el.style.animationDelay=(Math.random()*.28)+'s';
      box.appendChild(el);
    }
    document.body.appendChild(box);
    setTimeout(function(){ box.remove(); }, 2200);
  }
      if(barN){
        var nuevoN = c>=1 ? String(c) : '';
        // Solo animar cuando el numero CAMBIA de verdad: render() corre por
        // muchos motivos (cambio de color, re-render del drawer) y animar en
        // todos serian rebotes porque si.
        if(barN.textContent !== nuevoN){
          barN.textContent = nuevoN;
          // Forzar reflow para reiniciar la animacion: sin esto, dos toques
          // seguidos NO la vuelven a disparar (la clase ya esta puesta).
          if(c>=1){ barN.classList.remove('is-pop'); void barN.offsetWidth; barN.classList.add('is-pop'); }
        }
      }
      if(barCta){
        barCta.disabled = c<1;
        if(c>=1) barCta.setAttribute('aria-label','Listo, quiero comprar, '+c+(c===1?' prenda':' prendas')+' en tu pack');
        else barCta.removeAttribute('aria-label');
        if(!packBar._teluceChipsWired){
          packBar._teluceChipsWired=true;
          packBar.addEventListener('click', function(e){
            var chip=e.target.closest('[data-chip-remove]');
            if(!chip) return;
            var idx=parseInt(chip.getAttribute('data-chip-remove'),10);
            // Store.remove() lanza DESPUES de guardar (llama a un render() que
            // no existe en su IIFE). El dato queda bien; el repintado hay que
            // hacerlo aca, no darlo por hecho.
            try{ Store.remove(idx); }catch(err){}
            teluceTrack('slot_remove', {count: Store.count()});
            if(window.TeluceCatDrawer) window.TeluceCatDrawer.render();
            render();
          });
        }
        if(!barCta._teluceWired){
          barCta._teluceWired=true;
          barCta.addEventListener('click', function(){
            // El CTA abre el DRAWER del pack: ahi se revisa (nombres, swatches,
            // quitar) antes de confirmar. FALLBACK al confirm directo: si el
            // drawer no esta, el boton sigue funcionando como antes en vez de
            // quedar muerto.
            var cd=document.getElementById('TeluceCatalogDrawer');
            if(cd && typeof cd.show==='function'){
              if(window.TeluceCatDrawer) window.TeluceCatDrawer.render();
              teluceTrack('cat_drawer_open', {count: Store.count()});
              cd.show();
              return;
            }
            var conf=document.querySelector('[data-pack-confirm]');
            if(conf) conf.click();
          });
        }
      }
    }
    var actionHtml=
      (c>=1?
        '<div class="teluce-pack-summary">'+
          '<div class="teluce-pack-summary__row"><span>Subtotal</span><span>'+money(sum)+'</span></div>'+
          '<div class="teluce-pack-summary__row teluce-pack-summary__row--discount"><span>Descuento'+(pctVal?' (-'+pctVal+'%)':'')+'</span><span>'+(pctVal? '-'+money(save) : '$0')+'</span></div>'+
          '<div class="teluce-pack-summary__row teluce-pack-summary__row--total"><span>Total</span><span>'+money(c===1?sum:bPrice)+'</span></div>'+
        '</div>'
      : '')+
      confirmBtn+
      '<div class="teluce-pack-msg" data-pack-msg></div>';
    // Solo en el PDP: el bloque Agregar (o el límite de 3 con WhatsApp)
    var addHtml = c===3?
      '<div class="teluce-pack-max">'+
        '<p class="teluce-pack-max__copy">Si deseas pedir más unidades de nuestras básicas, te podemos dar precio para mayoristas '+
        '<a class="teluce-whatsapp teluce-pack-max__wa" href="https://wa.me/573178315988?text='+encodeURIComponent('Hola! Quiero comprar más de 6 básicas')+'" target="_blank" rel="noopener">'+
          '<svg viewBox="0 0 24 24" fill="currentColor" class="icon" aria-hidden="true"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.52.149-.174.198-.298.297-.497.1-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>'+
          'Escríbenos'+
        '</a>'+
        '</p>'+
      '</div>'
    : '<button class="button button--secondary teluce-pack-add" data-pack-add>'+addLabel+'</button>';
    var baseHtml=
      '<div class="teluce-pack-head"><h3>Elige tu prenda o arma tu pack</h3><p class="teluce-pack-subhead">'+subheads[c]+'</p></div>'+
      '<div class="teluce-pack-tiers">'+

        // Tramos de la campana: 4 y 6. Los que dan premio dicen GRATIS con el
        // dorado; los que no dan nada NO muestran pill (anunciar "precio full"
        // es vender en contra). Antes decian 2/3 prendas con -10%/-15%: copy
        // de la oferta anterior, que ya no existe.
        '<span class="teluce-pack-tier'+(c<4?' is-active':'')+'"><span class="teluce-pack-tier__label">4 básicas</span><span class="teluce-pack-tier__value">GRATIS</span></span>'+
        '<span class="teluce-pack-tier teluce-pack-tier--free'+(c<4?'':' is-active')+'"><span class="teluce-pack-tier__label">6 básicas</span><span class="teluce-pack-tier__value">GRATIS</span></span>'+
      '</div>'+
      '<div class="teluce-pack-bar"><div class="teluce-pack-fill" style="width:'+(c/6*100)+'%"></div></div>'+
      slotsHtml;
    var hostHtml='<div class="teluce-pack-builder">'+baseHtml+addHtml+actionHtml+'</div>';
    if(host) host.innerHTML=hostHtml;
    var dBuilder=document.getElementById('teluce-drawer-builder');
    if(dBuilder){
      // drawer: HEAD storytelling (subhead fuera del builder) + builder con
      // su head "Arma tu pack" (sin subhead) — slots de invitación iguales
      var headNoSub=baseHtml.replace(/<p class="teluce-pack-subhead">[\s\S]*?<\/p>/,'');
      dBuilder.innerHTML='<div class="teluce-story-head">'+storyHead(c)+'</div>'
        +'<div class="teluce-pack-builder">'+headNoSub+'</div>';
      // capricho: en step 0 (slots vacíos) el head storytelling tipea en loop
      if(c===0){
        var sh=dBuilder.querySelector('.teluce-story-head');
        if(sh) typeStoryHead(sh);
      }
    }
    // persistencia entre PDPs: todo slot lleno carga sus colores si no están
    // cacheados (el cache vive en sessionStorage)
    Store.slots.filter(Boolean).forEach(function(s){ if(s&&s.handle) maybeLoadColors(s.handle); });
    // confeti al activar un tier (2ª o 3ª blusa) — estilo "me gusta" de YouTube
    if(activatedTier && host){
      var pill=host.querySelector('.teluce-pack-tier.is-active');
      if(pill) spawnConfetti(pill);
    }
    lastCount=c;
    refreshStableBar();
  }
  var lastCount=Store.count();
  function spawnConfetti(el){
    if(!el) return;
    var box=document.createElement('div');
    box.className='teluce-confetti';
    var colors=['#b4552d','#e8a33d','#FFC0CB','#25D366','#005BD3','#9A5630'];
    for(var i=0;i<16;i++){
      var s=document.createElement('span');
      var ang=Math.random()*Math.PI*2;
      var dist=28+Math.random()*48;
      s.style.setProperty('--dx',(Math.cos(ang)*dist).toFixed(0)+'px');
      s.style.setProperty('--dy',(Math.sin(ang)*dist-18).toFixed(0)+'px');
      s.style.setProperty('--rot',(Math.random()*360-180).toFixed(0)+'deg');
      s.style.background=colors[i%colors.length];
      s.style.animationDelay=(Math.random()*0.12).toFixed(2)+'s';
      box.appendChild(s);
    }
    el.appendChild(box);
    setTimeout(function(){ if(box.parentNode) box.remove(); },1400);
  }
  render();
  // events — delegación a document: los builders viven en PDP Y en el
  // drawer (estado selección); el mismo click debe funcionar en ambos.
  document.addEventListener('click',function(e){
    var col=e.target.closest('[data-slot-color]'); if(col){
      var idx=parseInt(col.getAttribute('data-slot-color'),10);
      var vid=col.getAttribute('data-variant');
      var cur=Store.slots[idx];
      if(cur){
        var vs=productVariantsCache[cur.handle]||[];
        for(var q=0;q<vs.length;q++){
          if(String(vs[q].id)===String(vid)){
            Store.replace(idx,{variantId:String(vs[q].id), productId:cur.productId, handle:cur.handle, title:cur.title, variantTitle:vs[q].color, color:vs[q].color, image:vs[q].img, price:vs[q].price||cur.price});
            break;
          }
        }
      }
      return;
    }
    var rm=e.target.closest('[data-remove]'); if(rm){ Store.remove(parseInt(rm.getAttribute('data-remove'),10)); teluceTrack('slot_remove', {count: Store.count()}); return; }
    var conf=e.target.closest('[data-pack-confirm]'); if(conf){ teluceTrack('confirm', {count: Store.count(), tier: Store.count()}); PackAssembler.addPack(Store.slots.filter(Boolean)); return; }
  });
  // handler GLOBAL del CTA "Agregar a la compra" (vive en la botonera, fuera del builder)
  document.addEventListener('click',function(e){
    var add=e.target.closest('[data-pack-add]'); if(!add) return;
    var slot=getCurrentSlot(); var msg=host?host.querySelector('[data-pack-msg]'):null;
    if(!slot){ if(msg) msg.textContent='Elige una variante disponible'; return; }
    var ok=Store.add(slot);
    if(msg) msg.textContent= ok? 'Agregado ✓' : 'Ya la tienes en tu carrito';
    setTimeout(function(){if(msg) msg.textContent='';},2000);
    // mobile: auto-scroll al builder pack — la screen enfoca desde el trust
    // strip (Envío gratis / COD / Sin costos) hasta asomar el proceso de
    // pedido, dejando el pack builder CENTRADO y principal (el tab bar vive
    // en bottom, el precio/desglose no debe tapar el CTA de compra)
    if(ok && host && window.matchMedia('(max-width: 749px)').matches){
      setTimeout(function(){
        var trust=host.querySelector('.teluce-trust-strip')||document.querySelector('.product__info-wrapper .teluce-trust-strip');
        if(trust){
          var top=trust.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo({top: Math.max(0, top - 6), behavior:'smooth'});
        } else {
          var target=host.closest('.product__info-wrapper')||host;
          if(target && target.scrollIntoView) target.scrollIntoView({behavior:'smooth', block:'center'});
        }
      }, 80);
    }
  });
  // PackAssembler
  // PRODUCTOS PACK (vía "precio ya descontado", no descuento):
  // Releasit re-preciifica desde SU data y su backend NO descuenta órdenes
  // multi-producto (verificado con pedido test). La solución: productos
  // virtuales "TE LUCE X2/X3" con el precio YA descontado (X2 = $118.830,
  // X3 = $157.275 para prendas de $69.900). El builder agrega el pack como
  // UNA línea con la composición en properties (para fulfillment).
  // Los productos están DESPUBLICADOS del Online Store (invisibles en
  // catálogo/sitemap/búsqueda) — por eso se usan VARIANT IDs directos y
  // NO el fetch /products/<handle>.js (que exige publicación). Si se
  // recrean los productos O se editan sus variantes (renombrar opciones
  // regenera los IDs), actualizar estos IDs.
  // ============================================================
  // PACKS CON PRECIOS VARIADOS (escalable): ya NO se usan productos pack
  // virtuales con precio fijo. Se agregan las prendas REALES al carrito y
  // se inyecta un CÓDIGO DE DESCUENTO (order discount, % del total) de
  // forma SILENCIOSA vía /cart/update.js — el cliente nunca escribe nada.
  //   - (mecanica vieja por porcentaje, en desuso)
  //   - (mecanica vieja por porcentaje, en desuso)
  // Los códigos viven en el Admin (Descuentos). El descuento se calcula
  // dinámicamente sobre el total real → sirve con cualquier precio.
  // ============================================================
   var PackAssembler={
    addPack: async function(slots){
      var valid=slots.filter(Boolean);
      if(valid.length<1) return false;
      var msgEl=host?host.querySelector('[data-pack-msg]'):null;
      var btn=host?host.querySelector('[data-pack-confirm]'):null;
      var success=false;
      // carrito ANTES: si ya tiene líneas es una ACTUALIZACIÓN (reemplazo
      // atómico de la compra anterior — el carrito es UNA unidad)
      var before=null, beforeKeys=[], beforeItems=[], isUpdate=false;
      try{ var r0=await fetch('/cart.js'); if(r0.ok) before=await r0.json(); }catch(e){}
      if(before && before.items){
        beforeKeys=before.items.map(function(it){return it.key;});
        beforeItems=before.items.map(function(it){ return {id:it.variant_id, quantity:it.quantity, properties:it.properties||{}}; });
      }
      isUpdate = beforeKeys.length>0;
      if(btn) btn.disabled=true, btn.textContent= isUpdate? 'Actualizando…' : 'Agregando…';
      // Prendas REALES + código de descuento (order discount %).
      // 1 = línea directa; 2-3 = líneas reales (el % lo aplica el descuento automático)
      var items;
      if(valid.length===1){
        try{ sessionStorage.setItem('teluce_single','1'); }catch(e){}
        items=[{id:parseInt(valid[0].variantId,10),quantity:1}];
      } else {
        items=valid.map(function(s){ return {id:parseInt(s.variantId,10),quantity:1}; });
      }
      // rollback: re-agrega la compra anterior (la quitamos en el update)
      async function restoreBefore(){
        if(!beforeItems.length) return;
        try{ await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:beforeItems})}); }catch(e){}
      }
      try{
        // UPDATE = reemplazo atómico: QUITAR la compra anterior PRIMERO.
        // El producto pack (X2/X3) tiene stock 1 — si el viejo sigue en el
        // carrito, /cart/add del nuevo falla por exceso de stock.
        if(isUpdate && beforeKeys.length){
          for(var bi=0;bi<beforeKeys.length;bi++){
            try{ await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:beforeKeys[bi],quantity:0})}); }catch(e){}
          }
        }
        var res=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})});
        if(!res.ok){
          var err=await res.text();
          throw new Error(err||'No se pudo agregar');
        }
        var cart=await res.json();
        // verificación all-or-nothing: TODAS las prendas elegidas presentes
        var allOk=valid.every(function(s){
          return cart.items.some(function(it){ return String(it.variant_id)===String(s.variantId); });
        });
        if(!allOk){ await restoreBefore(); throw new Error('No se pudo agregar'); }
        success=true;
        // aplicar el descuento del pack (silencioso, order discount %)
        // el descuento se aplica al carrito de Releasit (no bloquea el sync)
        // publish cartUpdate (header count).
        if(window.publish) publish(PUB_SUB_EVENTS.cartUpdate,{source:'teluce-pack',cartData:cart});
        // PLAN C: recargar con ?teluce-pack=1 — el overlay de la página nueva
        // anima completo (sin el flash estático de la página vieja, que
        // causaba el doble show: aparecía, la navegación lo mataba y
        // reaparecía animando).
        // SIN flags de compra pendiente: el flujo es re-sincronizar siempre.
        try{ window.location.href = window.location.pathname + '?teluce-pack=1'; }catch(e){}
        return true;
      }catch(err){
        // intentar restaurar la compra anterior si la quitamos (update fallido)
        if(isUpdate){ try{ await restoreBefore(); }catch(e){} }
        if(msgEl) msgEl.textContent= err.message.includes('Stock')? 'Sin stock, prueba otro color' : 'No se pudo actualizar la compra. Reintenta.';
        if(btn) btn.disabled=false;
        return false;
      }finally{
        // re-render will reset btn via Store.clear or count check
        render();
        if(success && msgEl){
          var label=valid.length===3?'15%':'10%';
          msgEl.textContent='¡Agregado! Descuento '+label+' incluido en el precio.';
        }
      }
    }
  };
  window.TelucePackAssembler=PackAssembler;
  // syncStoreToCart vive en ESTE IIFE; el drawer del catalogo esta en otro.
  // Se expone para que su confirm use la ruta CORTA (sin recarga) en vez de
  // addPack, que recarga y abre el drawer legacy como paracaidas.
  window.TelucePackSync={ run: syncStoreToCart };
  window.TeluceMixMatchStore=Store;
  // ============================================================
  // SYNC STABLE BUYBAR → CARRITO (SIN recarga): espejo de
  // PackAssembler.addPack — 1 = variante directa; 2-3 = prendas reales +
  // + descuento automático por cantidad (Admin); reemplazo
  // atómico remove-first (el pack tiene stock 1) + rollback si falla. A
  // diferencia de addPack NO recarga: el drawer queda siempre cart-mounted
  // detrás y el buybar estable (fuera del re-render de Craft) hace proxy al
  // buy-now de Releasit. Devuelve true/false; publica cartUpdate para que
  // Releasit re-renderice su botón con tamaño real.
  async function syncStoreToCart(){
    var valid=Store.slots.filter(Boolean);
    if(valid.length<1) return false;
    var items;
    if(valid.length===1){
      items=[{id:parseInt(valid[0].variantId,10),quantity:1}];
    } else {
      // prendas REALES (precios variados) + código de descuento al final
      items=valid.map(function(s){ return {id:parseInt(s.variantId,10),quantity:1}; });
    }
    // carrito ANTES: si ya tiene líneas es una ACTUALIZACIÓN (reemplazo)
    var before=null, beforeKeys=[], beforeItems=[], isUpdate=false;
    try{ var r0=await fetch('/cart.js'); if(r0.ok) before=await r0.json(); }catch(e){}
    if(before && before.items){
      beforeKeys=before.items.map(function(it){return it.key;});
      beforeItems=before.items.map(function(it){ return {id:it.variant_id, quantity:it.quantity, properties:it.properties||{}}; });
    }
    isUpdate=beforeKeys.length>0;
    async function restoreBefore(){
      if(!beforeItems.length) return;
      try{ await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:beforeItems})}); }catch(e){}
    }
    try{
      // LIMPIEZA ATOMICA: /cart/clear.js elimina TODO el carrito (incluye
      // residuales de intentos previos tras cerrar Releasit — el remove-first
      // línea por línea podía dejar prendas viejas que luego Releasit leía).
      // Después se agregan SOLO las prendas del pack actual.
      try{
        await fetch('/cart/clear.js',{method:'POST'});
      }catch(e){}
      // pequeño delay para que el clear asiente antes del add
      await new Promise(function(r){ setTimeout(r, 60); });
      var res=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})});
      if(!res.ok){ var err=await res.text(); throw new Error(err||'No se pudo agregar'); }
      var cart=await res.json();
      // verificación all-or-nothing: TODAS las prendas elegidas presentes
      var allOk=valid.every(function(s){
        return cart.items.some(function(it){ return String(it.variant_id)===String(s.variantId); });
      });
      if(!allOk){ await restoreBefore(); throw new Error('No se pudo agregar'); }
      // aplicar el descuento del pack (silencioso, order discount %)
      // el descuento se aplica al carrito de Releasit (no bloquea el sync)
      var drawer=document.querySelector('cart-drawer');
      if(drawer) drawer.classList.remove('is-empty');
      if(window.publish) publish(PUB_SUB_EVENTS.cartUpdate,{source:'teluce-pack',cartData:cart});
      return true;
    }catch(err){
      // rollback: restaurar la compra anterior si la quitamos (update fallido)
      if(isUpdate){ try{ await restoreBefore(); }catch(e){} }
      return false;
    }
  }

  // helper público para el HERO-PACK del catálogo (sections/teluce-pack-catalog):
  // devuelve las variantes con color/foto del handle (cache o fetch)
  window.teluceGetVariants=function(handle){
    if(!handle) return Promise.resolve([]);
    if(productVariantsCache[handle]) return Promise.resolve(productVariantsCache[handle]);
    return fetch('/products/'+handle+'.js').then(function(r){return r.json();}).then(function(d){
      productVariantsCache[handle]=extractColors(d);
      cacheTS[handle]=Date.now();
      persistColorCache();
      return productVariantsCache[handle];
    }).catch(function(){ return []; });
  };
  // Plan C: tras confirmar un pack, la página recarga con ?teluce-pack=1 y
  // el carrito YA tiene el pack → el drawer viene renderizado server-side.
  // El overlay brandeado se mantiene un mínimo (MIN_HOLD) para transmitir el
  // mensaje y cubre el render del drawer; recién ahí abre con crossfade.
  // SIN MICROMOMENTO (glass card): tras confirmar (recarga ?teluce-pack=1),
  // el drawer abre directo — sin overlay "Compra actualizada"/"Lucir más es
  // ahorrar más". El confeti de tiers prevalece (se dispara en el drawer).
  if(window.location.search.indexOf('teluce-pack=1')!==-1){
    setTimeout(function(){
      var drawer=document.querySelector('cart-drawer');
      if(!drawer) return;
      var inner=drawer.querySelector('.drawer__inner');
      if(inner && inner.classList.contains('is-empty')) inner.classList.remove('is-empty');
      drawer.classList.remove('is-empty');
      drawer.classList.add('animate','active');
      document.body.classList.add('overflow-hidden');
      try{ window.history.replaceState({},'',window.location.pathname); }catch(e){}
      setTimeout(function(){
        if(window.publish && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate,{source:'cart-items'});
      },400);
    }, 150);
  }
  // ============================================================
  // BARRA "TU COMPRA EN CURSO" — sticky, siempre presente cuando el
  // carrito tiene productos (en todas las páginas). Muestra count +
  // total y abre el drawer (la superficie de confirmación + pago).
  // ============================================================
  // badge del tab Carrito (mobile): "grita" cuando hay compra en curso
  function updateCartBadge(){
    var badges=document.querySelectorAll('[data-cart-badge]');
    if(!badges.length) return;
    function setBadge(v){
      badges.forEach(function(badge){
        var tab=badge.closest('[data-teluce-open-cart]');
        if(v>0){
          badge.textContent=v;
          badge.hidden=false;
          badge.classList.add('teluce-cart-badge--active');
          if(tab) tab.classList.add('teluce-mobile-tab--has-purchase');
        } else {
          badge.hidden=true;
          badge.classList.remove('teluce-cart-badge--active');
          if(tab) tab.classList.remove('teluce-mobile-tab--has-purchase');
        }
      });
    }
    // el badge refleja la SELECCIÓN del builder (Store), no el carrito:
    // el carrito es solo un proxy de sync y puede quedar con un pack viejo
    // aunque la selección esté vacía → badge fantasma.
    setBadge(Store.count());
  }
  // ============================================================
  // DRAWER DE DOS ESTADOS — Estado 1 (selección): el pack builder
  // siempre accesible. Estado 2 (checkout): desglose + buy-now Releasit
  // (aparece tras confirmar, via ?teluce-pack=1).
  // ============================================================
  // head storytelling del drawer (estilo Knaflic): el kicker (contexto)
  // en pequeño/light, el dato del momento (ordinal, %) en grande/terracota.
  var STORY_HEAD=[
    {k:'Empieza a lucir,', m:'elige tu <span class="tl-data">1.ª</span> prenda'},
    {k:'Qué tal lucir doble,', m:'con la <span class="tl-data">2.ª</span>, de regalo'},
    {k:'Ya tienes tu tu premio,', m:'¿la <span class="tl-data">3.ª</span> para el segundo?'},
    {k:'Luciste en grande:', m:'ya lo tienes, un dos de regalo'}
  ];
  function storyHead(c){
    var s=STORY_HEAD[c]||STORY_HEAD[0];
    // CTA de navegación SOLO en páginas sin builder PDP (home, catálogo…):
    // el drawer invita a elegir y este CTA lleva a buscar. En el PDP sobra
    // (ahí vive el botón Agregar). Con pack completo (3) se oculta.
    var cta='';
    // CTA de navegación SOLO en HOME (el drawer en el catálogo no invita a
    // "ver catálogo" — ya estás en él). En el PDP tampoco (host=true).
    var onHome = window.location.pathname==='/' || window.location.pathname==='';
    if(!host && onHome && c<3){
      cta='<a class="tl-browse" href="/collections/all">'+(c===0?'Ver catálogo':'Seguir mirando')+'</a>';
    }
    return '<div class="tl-copy"><p class="tl-kicker">'+s.k+'</p><p class="tl-main">'+s.m+'</p></div>'+cta;
  }
  // typewriter en loop del head storytelling (step 0, slots vacíos) — mismo
  // patrón que el indicador: tipea kicker → main → pausa → borra → loop.
  // Preserva el <span class="tl-data"> terracota del main (ej. 1.ª) durante
  // el tipeo, reserva el espacio vertical y hace bubble al CTA Ver catálogo
  // DESPUÉS de cada tipeo completo (secuencial).
  function typeStoryHead(container){
    var k=container.querySelector('.tl-kicker'), m=container.querySelector('.tl-main');
    if(!k||!m) return;
    if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    container.classList.add('is-typing');
    var kt=k.textContent;
    var fullMainHTML=m.innerHTML;
    // RESERVAR la altura final EXACTA: mide con el texto completo renderizado
    // (en mobile el main envuelve a 2 líneas → el min-height estático no basta).
    // Así el tipeo/borrado nunca altera el espacio ni desalinea el CTA.
    k.textContent=kt;
    m.innerHTML=fullMainHTML;
    container.style.minHeight=container.offsetHeight+'px';
    k.textContent=''; m.innerHTML='';
    // segmentos del main: texto + span (mantiene el color terracota)
    var segs=[];
    var tmp=document.createElement('div');
    tmp.innerHTML=fullMainHTML;
    Array.prototype.slice.call(tmp.childNodes).forEach(function(n){
      if(n.nodeType===3) segs.push({plain:n.nodeValue||'', html:n.nodeValue||''});
      else segs.push({plain:n.textContent||'', html:n.outerHTML||''});
    });
    function mtLen(){ var n=0; segs.forEach(function(s){ n+=s.plain.length; }); return n; }
    function renderMain(i){
      var out='', remain=i;
      for(var s=0;s<segs.length && remain>0;s++){
        var take=Math.min(remain, segs[s].plain.length);
        out+= take===segs[s].plain.length ? segs[s].html : segs[s].plain.slice(0,take);
        remain-=take;
      }
      return out;
    }
    function bubbleBrowse(){
      var b=container.querySelector('.tl-browse');
      if(b){ b.classList.remove('teluce-bubble'); void b.offsetWidth; b.classList.add('teluce-bubble'); }
    }
    var phase=0, i=0;
    function tick(){
      if(phase===0){
        if(i<=kt.length){ k.textContent=kt.slice(0,i); i++; setTimeout(tick,28); }
        else { phase=1; i=0; m.classList.add('teluce-typing'); setTimeout(tick,320); }
      } else if(phase===1){
        if(i<=mtLen()){ m.innerHTML=renderMain(i); i++; setTimeout(tick,30); }
        else { phase=2; m.classList.remove('teluce-typing'); bubbleBrowse(); setTimeout(tick,2400); }
      } else if(phase===2){
        phase=3; i=mtLen(); m.classList.add('teluce-typing'); setTimeout(tick,80);
      } else if(phase===3){
        if(i>=0){ m.innerHTML=renderMain(i); i--; setTimeout(tick,16); }
        else { phase=4; i=kt.length; m.classList.remove('teluce-typing'); setTimeout(tick,60); }
      } else {
        if(i>=0){ k.textContent=kt.slice(0,i); i--; setTimeout(tick,16); }
        else { phase=0; i=0; setTimeout(tick,900); }
      }
    }
    tick();
  }
  // PROCESO DE COMPRA funcional (MERGE): 2 pasos — 1=elegir, 2=solicitar.
  // El "último vistazo" se eliminó: el drawer de elección ES el review
  // (slots + desglose + buy-now sticky). Los dots flex:1 centran en
  // 25% / 75% del track → línea blanca 0% / 100%.
  // STABLE BUYBAR: el desglose (Total sin descuento / Descuento / Total)
  // refleja la SELECCIÓN del builder — es EL review de precios. La barra
  // vive FUERA de .drawer__inner (hermana del panel), así Craft no la
  // re-renderiza en cada cambio de carrito. Recalcula en render() +
  // setDrawerState() (mixMatchUpdate / cartUpdate).
  function updateStableBreakdown(){
    var c=Store.count();
    var valid=Store.slots.filter(Boolean);
    var sum=valid.reduce(function(a,b){return a+b.price;},0);
    var bPrice=bundlePrice();
    var save=c>=2 ? (sum-bPrice) : 0; // 1 blusa = sin descuento
    var origVal=document.querySelector('[data-stable-bd-original-value]');
    var discVal=document.querySelector('[data-stable-bd-discount-value]');
    var discLabel=document.querySelector('[data-stable-bd-discount-label]');
    var totEl=document.querySelector('[data-stable-bd-total]');
    var origRow=document.querySelector('[data-stable-bd-original]');
    var discRow=document.querySelector('[data-stable-bd-discount]');
    if(c<1){ if(origRow) origRow.style.display='none'; if(discRow) discRow.style.display='none'; if(totEl) totEl.textContent='$0'; return; }
    // El drawer muestra SIEMPRE los valores LIMPIOS del Store (enteros, los
    // precios reales de las prendas). NO se leen los del carrito real: al
    // abrir Releasit, Shopify reparte el descuento automático entre las
    // líneas y deja precios con decimales raros (28.900 / 95.259,00) que no
    // son los que el cliente debe ver en el drawer.
    if(origVal) origVal.textContent=money(sum);
    if(discVal) discVal.textContent='−'+money(save);
    if(discLabel && c>=2) discLabel.textContent='Descuento (-'+(c===3?15:10)+'%)';
    if(origRow) origRow.style.display=save>0?'':'none';
    if(discRow) discRow.style.display=save>0?'':'none';
    if(totEl) totEl.textContent=money(c===1?sum:bPrice);
  }
  // refreshStableBar: quita el display:none inline inicial para que el CSS
  // (cart-drawer.active #teluce-stable-buybar) gobierne la visibilidad —
  // oculto con el drawer cerrado, visible al abrir. Nunca se pelea por
  // display con Craft (#CartDrawer-Checkout queda oculto para siempre).
  function refreshStableBar(){
    var bar=document.getElementById('teluce-stable-buybar');
    if(!bar) return;
    updateStableBreakdown();
    // con 0 prendas la barra de compra NO aparece (solo con ≥1 blusa)
    var c=Store.count();
    bar.style.display = c<1 ? 'none' : '';
    // el contenido (builder + shipping) debe despejar la barra fija: el
    // padding del drawer = altura REAL de la barra + gap (la barra mide más
    // que el padding estático 140px → sin esto el shipping queda tapado).
    // Con la barra oculta (display:none) offsetHeight=0 → padding mínimo.
    var inner=document.querySelector('cart-drawer .drawer__inner');
    if(inner){
      var h=bar.offsetHeight||0;
      inner.style.paddingBottom=(h+12)+'px';
    }
  }
  function ensureDrawerBuilder(){
    var drawer=document.querySelector('cart-drawer');
    if(!drawer) return;
    var holder=drawer.querySelector('.drawer__inner');
    if(!holder || holder.querySelector('#teluce-drawer-builder')) return;
    var div=document.createElement('div');
    div.id='teluce-drawer-builder';
    var extras=holder.querySelector('#teluce-drawer-extras');
    if(extras) holder.insertBefore(div, extras); else holder.appendChild(div);
  }
  function setDrawerState(){
    var drawer=document.querySelector('cart-drawer');
    if(!drawer) return;
    // Craft re-renderiza .drawer__inner (innerHTML server fresco) en cada
    // cambio de carrito → el #teluce-drawer-builder inyectado se borra.
    // Re-crearlo SIEMPRE aquí antes de renderizar.
    ensureDrawerBuilder();
    // el step-by-step del drawer nace con js-animate (iconos ocultos) y su
    // IntersectionObserver nunca dispara dentro del drawer cerrado → revelar
    // la animación al abrir (una vez, como en el PDP)
    var prog=drawer.querySelector('#teluce-drawer-extras .teluce-shipping-progress');
    if(prog && !prog.classList.contains('is-visible')) prog.classList.add('is-visible');
    // REGLA cart-based: el drawer refleja la ETAPA de la compra, no la
    // selección del builder.
    // MERGE: el drawer SIEMPRE es el builder (slots + resumen). Sin lógica
    // de compra pendiente — el usuario cambia y vuelve a "Listo, quiero
    // comprar" (el sync re-monta todo).
    drawer.classList.add('teluce-state-builder');
    drawer.classList.remove('teluce-state-checkout');
    render();
    // stable buybar: desglose + visibilidad (fuera del re-render de Craft)
    refreshStableBar();
  }
  ensureDrawerBuilder();
  setDrawerState();
  // STABLE BUYBAR: listener único del botón "Solicitar compra". Vive fuera
  // del re-render de Craft → el listener sobrevive. Sincroniza SIN recarga
  // (syncStoreToCart) cuando la selección cambió y hace proxy al buy-now
  // oculto de Releasit (o al checkout nativo como fallback).
  (function(){
    var btn=document.getElementById('teluce-stable-buybtn');
    if(!btn) return;
    // El boton tiene label propio y spinner en su markup. OJO: antes esto
    // hacia btn.textContent = '…', que DESTRUYE el <span> del icono y lo
    // borraba para siempre, y ademas dejaba el texto en 'Confirmar pedido'
    // cuando el copy original es 'Listo, quiero comprar'.
    var buyLabel = btn.querySelector('.teluce-stable-buybtn__label');
    var BUY_TEXT = (buyLabel && buyLabel.textContent.trim()) || 'Listo, quiero comprar';
    var buyBusy = false;
    function setBuyLoading(on, text){
      buyBusy = !!on;
      if(buyLabel) buyLabel.textContent = text || BUY_TEXT;
      else btn.textContent = text || BUY_TEXT;
      btn.classList.toggle('is-loading', !!on);
      btn.disabled = !!on;
      btn.setAttribute('aria-busy', on ? 'true' : 'false');
    }
    btn.addEventListener('click', async function(){
      if(Store.count()<1) return;
      if(buyBusy) return;
      // SIEMPRE sincroniza la selección actual al carrito y va al form de
      // Releasit — sin snapshot de "compra confirmada" ni actualización.
      setBuyLoading(true, 'Actualizando…');
      var ok=await syncStoreToCart();
      if(!ok){ setBuyLoading(false); return; }
      // De aca en adelante sigue cargando: la espera real es Releasit montando
      // su form. Si soltamos el boton aca, la clienta lo ve como si no hubiera
      // pasado nada y vuelve a apretar.
      setBuyLoading(true, 'Preparando tu pedido…');
      // el carrito ya tiene la compra → disparar el buy-now de Releasit.
      // Releasit re-renderiza su botón tras el cartUpdate del sync; si aún
      // no montó, reintentar unos instantes antes del fallback nativo.
      // Mismo instrumentado que el drawer: este es el OTRO camino al buy-now
      // de Releasit (el buybar estable). Sin esto, el confirm del buybar no
      // dejaba rastro en Clarity y parecia que no habia dato.
      var tb = (window.performance && performance.now) ? performance.now() : Date.now();
      var markB = function(step){
        var t2 = (window.performance && performance.now) ? performance.now() : Date.now();
        var ms = Math.round(t2 - tb);
        teluceTrack('confirm_step', { step: step, ms: ms, via: 'buybar' });
        return ms;
      };
      // El form tarda en aparecer: el boton se suelta recien cuando el dialog
      // de Releasit esta EN PANTALLA, no cuando su boton aparece. Si no, el
      // spinner y el shimmer se apagan justo durante la espera.
      function doneWaitForm(){
        teluceWaitForForm(function(opened){
          markB(opened ? 'form_open' : 'form_timeout');
          setBuyLoading(false);
        });
      }
      // Para los caminos que van al checkout de Shopify no hay form de Releasit
      // que esperar.
      function doneFast(){ setTimeout(function(){ setBuyLoading(false); }, 1500); }
      markB('start');
      var rsi=document.getElementById('rsi_buy_now_button');
      if(rsi){
        // descuento AUTOMÁTICO del pack (configurado en el Admin de Shopify):
        // se aplica solo cuando el carrito cumple la condición — sin código.
        markB('button_found');
        rsi.click();
        var totB = markB('clicked');
        try{ if(window.clarity) window.clarity('set', 'confirm_ms', String(totB)); }catch(e){}
        doneWaitForm();
        return;
      }
      var cb=document.getElementById('CartDrawer-Checkout');
      if(cb && !cb.disabled){ markB('checkout_btn'); cb.click(); doneFast(); return; }
      var tries=0, t=setInterval(function(){
        tries++;
        var r2=document.getElementById('rsi_buy_now_button');
        if(r2){
          clearInterval(t); markB('button_found'); r2.click();
          var totB2 = markB('clicked');
          try{ if(window.clarity) window.clarity('set', 'confirm_ms', String(totB2)); }catch(e){}
          doneWaitForm();
          return;
        }
        var cb2=document.getElementById('CartDrawer-Checkout');
        if(cb2 && !cb2.disabled){ clearInterval(t); markB('checkout_btn'); cb2.click(); doneFast(); return; }
        // 100 x 60ms = ~6s. Antes eran 8 x 200ms = 1.6s: se quedaba corto y el
        // click quedaba sin efecto, EN SILENCIO. Ahora, si se rinde, lo dice.
        if(tries>=100){
          clearInterval(t);
          markB('gave_up');
          setBuyLoading(false, 'No pudimos abrir el pedido. Intenta de nuevo.');
        }
      },60);
    });
  })();
  // Fit Indicator ("¿Me queda?"): N medidas (busto + cintura). Cada fila trae
  // su medida mínima (data-fit-min) y el root la capacidad (data-fit-cap, %).
  // Zonas: HOLGADA (<mín) · CÓMODA (hasta 70% de la capacidad) · AJUSTADA (hasta
  // 100%) · NO TE QUEDA (>capacidad). El 70% es la perilla a calibrar.
  // El veredicto es POR MEDIDA (sin resumen combinado): cada fila se colorea con
  // su propia zona y así no choca contra el color de la otra medida.
  function initFitGuide(){
    var COMFORT = 0.7;
    var COPY = {
      holgada:  'te queda holgada',
      comoda:   'te queda cómoda',
      ajustada: 'te queda ajustada',
      no:       'te va a apretar'
    };
    function zoneOf(v, min, cap){
      if(v < min) return 'holgada';
      if(v <= min*(1+cap*COMFORT)) return 'comoda';
      if(v <= min*(1+cap)) return 'ajustada';
      return 'no';
    }
    function mount(root){
      if(root.dataset.fitReady) return;
      root.dataset.fitReady = '1';
      root.querySelectorAll('[data-fit-measure]').forEach(function(row){
        var min = parseFloat(row.getAttribute('data-fit-min'));
        // cap POR FILA: cada grupo (superior/inferior) tiene su capacidad.
        // 0 es VÁLIDO (tela que no estira): solo holgada o no te queda.
        var cap = parseFloat(row.getAttribute('data-fit-cap'))/100;
        if(!min || isNaN(cap)) return;
        var range = row.querySelector('[data-fit-range]');
        var number = row.querySelector('[data-fit-number]');
        var valueEl = row.querySelector('[data-fit-value]');
        function set(v){
          v = Math.round(v);
          if(isNaN(v)) return;
          if(range && String(range.value)!==String(v)) range.value = v;
          if(number && String(number.value)!==String(v)) number.value = v;
          var prevZone = row.getAttribute('data-fit-zone');
          var z = zoneOf(v, min, cap);
          row.setAttribute('data-fit-zone', z);
          if(valueEl) valueEl.textContent = COPY[z];
          // solo al CAMBIAR de zona (el slider dispara input en cada px)
          if(prevZone !== z) teluceTrack('fit_verdict', {zone: z, min: min});
        }
        if(range) range.addEventListener('input', function(){ set(parseFloat(range.value)); });
        if(number) number.addEventListener('input', function(){
          var n = parseFloat(String(number.value).replace(/[^0-9.]/g,''));
          if(!isNaN(n)) set(n);
        });
        set(number ? parseFloat(number.value) : min);
      });
    }
    function mountAll(){ document.querySelectorAll('[data-fit-guide]').forEach(mount); }
    mountAll();
    document.addEventListener('shopify:section:load', mountAll);
  }
  initPackCatalog(); // hero-pack del catálogo (si existe la sección)
  initFitGuide(); // indicador de calce (si existe el modal)
  if(host){
    initGalleryColors(); // dots de color bajo la galería (mobile)
    initGalleryVideo(); // video de galería: autoplay sin controles
    initGalleryVideoObserver(); // pausa fuera de pantalla / reanuda al volver
    initBuyDrawer(); // drawer de confirmación de compra (PDP)
    // el cache de sessionStorage puede traer colores stale (inventario
    // habilitado en admin con la pestaña abierta) → invalidar y re-pedir el
    // handle actual en CADA load de página; el cache sirve dentro de la página.
    var _h=(location.pathname.split('/products/')[1]||'').split('/')[0].split('?')[0];
    if(_h){
      delete productVariantsCache[_h];
      delete cacheTS[_h];
      maybeLoadColors(_h);
    }
  }
  if(window.subscribe && window.PUB_SUB_EVENTS) subscribe(PUB_SUB_EVENTS.cartUpdate, function(){ setTimeout(setDrawerState, 400); setTimeout(updateCartBadge, 400); });
  if(window.subscribe && window.PUB_SUB_EVENTS) subscribe(PUB_SUB_EVENTS.mixMatchUpdate, function(){ setTimeout(setDrawerState, 200); setTimeout(updateCartBadge, 200); setTimeout(updateRefMax, 100); });
  updateCartBadge();
  // ============================================================
  // VACIAR CARRITO AL COMPRAR: Releasit crea el draft order del COD sin
  // consumir el carrito de Shopify → queda lleno tras pagar. La app publica
  // el evento analytics "releasit_checkout_completed" con la orden justo al
  // crearla → nos suscribimos para vaciar carrito + resetear el pack.
  // ============================================================
  (function(){
    function vaciarTrasCompra(){
      fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
        if(!cart.item_count) return null;
        return fetch('/cart/clear.js',{method:'POST',headers:{'Content-Type':'application/json'}});
      }).then(function(){
        // resetea la selección del builder (badge, drawer, CTA del catálogo)
        try{ Store.clear(); }catch(e){}
        if(window.publish && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate,{source:'teluce-order-placed'});
        setTimeout(updateCartBadge, 400);
      }).catch(function(){});
    }
    // El theme NO tiene analytics.subscribe (solo publish, que es de la
    // tienda). Solución determinística: ENVOLVER analytics.publish — cuando
    // la app publique 'releasit_checkout_completed' (creación del draft
    // order COD), nuestro wrapper vacía el carrito antes del publish real.
    // Con retry: Shopify.analytics puede no estar montado aún en init.
    // Re-envuelve cada 500ms hasta 15s: Shopify MONTA analytics en varias
    // fases y puede reemplazar el objeto → detectar si publish ya es nuestro
    // wrapper (por el nombre del evento) y re-envolver si se perdió.
    function _wrapAnalytics(){
      var a=window.Shopify&&window.Shopify.analytics;
      if(!a || !a.publish) return;
      try{
        if(a.publish.toString().indexOf('releasit_checkout_completed')!==-1) return;
      }catch(e){ return; }
      var _orig=a.publish;
      a.publish=function(name,payload){
        try{
          if(name==='releasit_checkout_completed' || (payload&&payload.order)){
            vaciarTrasCompra();
          }
        }catch(e){}
        return _orig.apply(this, arguments);
      };
    }
    _wrapAnalytics();
    var _waT=setInterval(_wrapAnalytics, 500);
    setTimeout(function(){ clearInterval(_waT); }, 15000); // techo 15s
    // fallback: si el evento llega como CustomEvent en window
    try{ window.addEventListener('releasit_checkout_completed', function(){ vaciarTrasCompra(); }); }catch(e){}
  })();
  // TAB WHATSAPP en el header desktop horizontal: reemplaza el ítem
  // "Contacto" del menú (que es dato de navegación del admin — no editable
  // por theme). Solo el nav desktop (#HeaderMenu-*); el drawer mobile
  // (HeaderDrawer-*) conserva Contacto. Misma URL que el rail compacto.
  (function(){
    var c=document.getElementById('HeaderMenu-contacto');
    if(!c) return;
    c.setAttribute('href','https://wa.me/573178315988');
    c.setAttribute('target','_blank');
    c.setAttribute('rel','noopener');
    var s=c.querySelector('span');
    if(s) s.textContent='WhatsApp';
  })();
  // re-inicializar los dots de galería tras el re-render de Craft (la
  // sección se reemplaza entera al cambiar variante)
  if(host && 'MutationObserver' in window){
    var gs=document.querySelector('#shopify-section-'+host.dataset.section)||document.querySelector('main');
    new MutationObserver(function(){ setTimeout(initGalleryColors, 250); setTimeout(initGalleryVideo, 300); setTimeout(initGalleryVideoObserver, 360); }).observe(gs,{childList:true,subtree:true});
  }
  // HEADER COMPACTO ANCLADO (desktop): aparece tras scrollear >200px y
  // reemplaza al header de Craft (que quedó fuera de vista). Solo desktop.
  (function(){
    var ch=document.getElementById('teluce-compact-header');
    if(!ch) return;
    var mq=window.matchMedia('(min-width: 750px)');
    var shown=false;
    function sync(){
      if(!mq.matches){ ch.classList.remove('is-visible'); return; }
      var show=window.scrollY>200;
      if(show!==shown){
        shown=show;
        ch.classList.toggle('is-visible', show);
      }
    }
    window.addEventListener('scroll', function(){ window.requestAnimationFrame(sync); }, {passive:true});
    mq.addEventListener ? mq.addEventListener('change', sync) : mq.addListener(sync);
    sync();
  })();
  // abre el drawer por el tab/ícono (helper global)
  window.teluceOpenDrawer=function(){
    var drawer=document.querySelector('cart-drawer');
    if(!drawer) return;
    if(!drawer.classList.contains('active')){
      drawer.classList.add('animate','active');
      document.body.classList.add('overflow-hidden');
    }
    setDrawerState();
    teluceTrack('drawer_open', {count: Store.count()});
  };
  // el tab Carrito (mobile) abre el drawer — global (todos los templates)
  document.addEventListener('click', function(e){
    var t=e.target.closest('[data-teluce-open-cart]');
    if(t){ e.preventDefault(); if(window.teluceOpenDrawer) window.teluceOpenDrawer(); }
  });
  // "Guía de talla" abierta (chip del catálogo o del PDP): embudo de la guía
  document.addEventListener('click', function(e){
    if(e.target.closest('[data-modal^="#TeluceSizeGuide"]')) teluceTrack('size_guide_open', {});
  });
  // ponytail demo asserts
  // ponytail: demo asserts, remove when harness exists
  console.assert(PackAssembler.addPack.length===1,'assembler arity');
  console.assert(typeof PackAssembler.addPack==='function','assembler fn');
})();
